<template>
  <div>
    <items-module-modal :data="modalData" :isActive="itemsModalActive" :modalTitle="itemsModalTitle"
      :onSubmit="onSubmitItem" :currentFormData="currentFormData" :fieldHash="currentItemsFieldHash"
      @isModalActive="setIsModalActive" />
    <div id="details" v-if="blocks.length > 0">
      <div v-if="blocks.length > 0" class="parent-block">
        <template v-for="(block, index) in blocks">
          <vx-card v-if="block.content_type === 'tabs' && actionType !== 'add'" :key="block.hash" :title="$displayLabel(block, 'title')" collapse-action>

            <vs-tabs class="tab-action-btn-fill-container">
              <vs-tab v-for="(blockTab, index) in blockTabs[block.hash]" :label="$displayLabel(blockTab, 'tabName')"
                :key="`${block.hash}-${index}`">

                <related-module-table v-if="Object.keys(detailProp).length > 0" :relatedTab="blockTab" :rowState="fieldModel"
                  @onChange="onRelatedTabChange($event)" :delegatorUrl="delegatorUrl" :parentRowHash="$route.params.rowHash" :readOnly="relatedReadOnly" />

              </vs-tab>
            </vs-tabs>
          </vx-card>

          <vx-card v-if="block.content_type === 'embbeded'" :key="block.hash" :title="$displayLabel(block, 'title')" collapse-action>
              <div id="div-with-loading" class="vs-con-loading__container">
                <iframe :ref="`iframe-${block.hash}`" :src="beforeFrameLoad(block.content_url)+`${beforeFrameLoad(block.content_url).includes('?') ? '&' : '?'}id=${block.hash}`" title="" :id="`iframe-${block.hash}`"
                frameborder="0" scrolling="no" @load="onFrameLoad(`iframe-${block.hash}`, $displayLabel(block, 'title'))" width="100%"></iframe>
              </div>
              <!-- &t=${Date.now()} -->
          </vx-card>


          <vx-card :key="block.hash" :title-html="$displayLabel(block, 'title') + `${block.fieldList && block.fieldList.length === 1 && block.fieldList[0][0].type_id === $FIELD_TYPES.MULTIPLE_DOCUMENTS && block.fieldList[0][0].mandatory ? ' <span style=&quot;color: #ff0000;&quot;>*</span>' : ''}`" v-else-if="block.content_type === 'fields' && block.fieldList && block.fieldList.length > 0" :is-collapsed="block.collapsed" collapse-action>
            <!-- <div class="vx-row mb-3" v-for="(fieldGroup, index) in block.fieldList" :key="index"> -->
            <div class="vx-row mb-3" v-for="(fieldGroup, index) in block.fieldList" :key="index">

              <template v-for="field in fieldGroup">
                <!-- <multiple-document-field :field="field" :viewMode="viewMode[field.hash]"
                      @onDelete="deleteDocument($event, field.hash)" @onSuccess="successUpload($event, field)"
                      @onOpenDocument="openDocument($event, fieldModel[field.hash])"
                      @onClickClose="closeImage(field.hash)" /> -->

                <div :class="'vx-col'" :style="fieldColumn(field.columns_on_form, detail.max_columns)" :key="field.hash"
                  v-if="fieldIsVisible(field.related_picklist_field_hash, field.related_picklist_item_hash)">

                  <div v-if="field.type_id === $FIELD_TYPES.IMAGE && viewMode[field.hash] && fieldModel[field.hash] !== null">
                    <label class="vs-input--label"> {{ $displayLabel(field, 'title') }} <span v-if="field.mandatory" style="color: red;"> *</span> </label>
                    <div class="con-upload">
                      <div class="con-img-upload">
                        <div class="img-upload">
                          <button type="button" class="btn-x-file" @click="closeImage(field.hash)"><i
                              translate="translate" class="material-icons notranslate">clear</i></button>
                          <img :src="fieldModel[field.hash]" style="max-width: 100%; max-height: none;"
                            @click="clickImage(fieldModel[field.hash])">
                        </div>
                        <!-- <div class="con-input-upload-custom disabled-upload upload-field-label">
                          <input type="file" accept="image/*" disabled="disabled"><span class="text-input">Enviar Arquivo</span>
                          <span class="input-progress" style="width: 0%;"></span>
                          <button type="button" disabled title="Upload"
                            class="btn-upload-all vs-upload--button-upload"><i translate="translate"
                              class="material-icons notranslate">cloud_upload</i></button>
                        </div> -->
                      </div>
                    </div>
                  </div>

                  <div v-else-if="field.type_id === $FIELD_TYPES.RICHTEXT" class="richtext-field" :class="{ 'quill-disabled': isFieldDisabled(field) }">
                    <quill-editor :ref="`quill-editor-${field.hash}`" v-model="fieldModel[field.hash]"></quill-editor>
                  </div>

                  <div
                    v-else-if="(field.type_id === $FIELD_TYPES.IMAGE && !viewMode[field.hash]) || (field.type_id === 21 && fieldModel[field.hash] === null)">
                    <label class="vs-input--label"> {{ $displayLabel(field, 'title') }} <span v-if="field.mandatory" style="color: red;"> *</span> </label>
                    <vs-upload text="Enviar Arquivo" :fileName="'file'" automatic
                      :action="$store.state.auth.api_url + '/save-image'" :accept="'image/*'"
                      :data="{ application_token: $store.state.auth.app_token, session_token: $store.state.auth.token }"
                      limit="1" single-upload @on-success="successUpload($event, field)"
                      @on-delete="deleteDocument($event, field.hash)" />
                  </div>


                  <div data-v-13a23bd0=""
                    v-if="field.type_id === 22 && viewMode[field.hash] && fieldModel[field.hash] !== null">
                    <label class="vs-input--label"> {{ $displayLabel(field, 'title') }} <span v-if="field.mandatory" style="color: red;"> *</span> </label>
                    <div data-v-13a23bd0="" class="con-upload">
                      <div class="con-img-upload">
                        <div class="img-upload">
                          <button type="button" class="btn-x-file" @click="closeImage(field.hash)"><i
                              translate="translate" class="material-icons notranslate">clear</i></button>
                          <!-- <button class="btn-upload-file" disabled><i translate="translate" class="material-icons notranslate">cloud_upload</i><span> %</span></button> -->
                          <img :src="fieldModel[field.hash]" style="max-width: 100%; max-height: none;"
                            @click="clickImage(fieldModel[field.hash])">
                        </div>
                        <div class="con-input-upload-custom disabled-upload upload-field-label">
                          <input type="file" accept="image/*" disabled="disabled"><span class="text-input">Enviar
                            Arquivo</span>
                          <span class="input-progress" style="width: 0%;"></span>
                          <button type="button" disabled title="Upload"
                            class="btn-upload-all vs-upload--button-upload"><i translate="translate"
                              class="material-icons notranslate">cloud_upload</i></button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-else-if="(field.type_id === $FIELD_TYPES.PHOTO && !viewMode[field.hash]) || (field.type_id === $FIELD_TYPES.PHOTO && fieldModel[field.hash] === null)">
                    <label class="vs-input--label"> {{ $displayLabel(field, 'title') }} <span v-if="field.mandatory" style="color: red;"> *</span> </label>
                    <vs-upload text="Enviar Arquivo" :fileName="'file'" automatic
                      :action="$store.state.auth.api_url + '/save-image'" :accept="'image/*'"
                      :data="{ application_token: $store.state.auth.app_token, session_token: $store.state.auth.token }"
                      limit="1" single-upload @on-success="successUpload($event, field)"
                      @on-delete="deleteDocument($event, field.hash)" />
                  </div>

                  <div
                    v-else-if="(field.type_id === $FIELD_TYPES.BADGE && !viewMode[field.hash]) || (field.type_id === $FIELD_TYPES.BADGE && fieldModel[field.hash] === null)">
                    <div class="vx-row">
                      <label class="vs-input--label"> {{ $displayLabel(field, 'title') }} <span v-if="field.mandatory" style="color: red;"> *</span> </label>
                    </div>
                    <div class="vx-row mt-1">
                      <vs-chip :color="fieldModel[field.hash].color"><span>{{ $displayLabel(fieldModel[field.hash], 'label')
                          }}</span></vs-chip>
                    </div>
                    <div class="vx-row" v-if="$i18n.locale !== 'en'">
                      <small id="small-subtitle" class="form-text text-muted" style="display: block;">{{ field.subtitle
                        }}</small>
                    </div>
                  </div>

                  <div v-else-if="field.type_id === $FIELD_TYPES.DOCUMENT">
                    <document-field :field="field" :viewMode="viewMode[field.hash]"
                      @onDelete="deleteDocument($event, field.hash)" @onSuccess="successUpload($event, field)"
                      @uploadPending="onDocumentUploadPending"
                      @onOpenDocument="openDocument($event, fieldModel[field.hash])"
                      @onClickClose="closeImage(field.hash)" :disabled="field.is_disabled" />
                  </div>

                  <div v-else-if="field.type_id === $FIELD_TYPES.MULTIPLE_DOCUMENTS">
                    <multiple-document-field :field="field" :screenMode="actionType"
                      @onDelete="deleteDocument($event, field.hash)" @onSuccess="successUploadMultiple($event, field)"
                      @onOpenDocument="openDocumentMultiple($event.event, $event.file)"
                      @onClickClose="closeImageMultiple(field.hash, $event)" :fieldModel="fieldModel[field.hash]" :newDocuments="newDocuments[field.hash]" />
                  </div>

                  <div v-else-if="field.type_id === $FIELD_TYPES.TABLE">
                    <div>
                      <vs-button
                        style="float: right!important;margin-bottom: 5px!important;margin-left: 10px!important;"
                        color="danger" type="filled" icon-pack="feather" icon="icon-trash"
                        v-if="selectedItemsRows[field.hash].length > 0"
                        @click="onMassDeleteItems(field.hash)">Excluir</vs-button>
                      <vs-button style="float: right!important;margin-bottom: 5px!important;"
                        @click="onAddItem(field.hash)" color="primary" type="filled" icon-pack="feather"
                        icon="icon-plus-circle">Adicionar</vs-button>
                    </div>
                    <items-module-table :fieldHash="field.hash" :data="fieldModel[field.hash]" :tableTitle="$displayLabel(field, 'title')"
                      :hash-field="tableHashFields[field.hash]" :titles="moduleItemsTitlesModel[field.hash]"
                      :onEditItem="onEditItem" :onDeleteItem="onDeleteItem"
                      @selectRowsChanged="onModuleItemsSelectedRowsChanged" />
                  </div>


                  <!-- START IF FIELD IS NOT IMAGE OR PHOTO-->
                  <div v-else>
                    <label class="vs-input--label"
                      v-if="field.type_id !== $FIELD_TYPES.IMAGE && field.type_id !== $FIELD_TYPES.PHOTO">{{ $displayLabel(field, 'title')
                      }} <span v-if="field.mandatory" style="color: red;"> *</span> </label>
                    <vx-input-group class="mb-0">
                      <!-- START IF FIELD HAS ICON -->
                      <template slot="prepend" v-if="field.secret">
                        <div class="prepend-text bg-primary" style="cursor: pointer!important;"
                          @click="secretFields[field.hash]['visible'] = !secretFields[field.hash]['visible']">
                          <span :is="secretFields[field.hash]['visible'] ? 'eye-icon' : 'eye-off-icon'" size="1x"
                            class="custom-class"></span>
                        </div>
                      </template>

                      <template slot="prepend"
                        v-else-if="(((field.type_id >= $FIELD_TYPES.PHONE && field.type_id <= $FIELD_TYPES.CURRENCY) || field.type_id === $FIELD_TYPES.MULTIPLE_DATE) && field.show_icon)">
                        <div class="prepend-text bg-primary">
                          <span :is="getIconFromFieldType(field.type_id)" size="1x" class="custom-class"></span>
                        </div>
                      </template>

                      <template slot="prepend" v-else-if="(field.type_id === $FIELD_TYPES.PUSH_TAGS_LIST)">
                        <div class="prepend-text bg-primary">
                          <span :is="getIconFromFieldType(field.type_id)" size="1x" class="custom-class"
                            style="cursor: pointer;" @click="clearPushTagsOptions(field.hash)"></span>
                        </div>
                      </template>
                      <!-- END IF FIELD HAS ICON -->

                      <div>
                        <!-- START IF FIELD HAS MASK -->
                        <div class="vx-input-group flex mb-0" v-if="field.mask && field.type_id === $FIELD_TYPES.PHONE">
                          <div class="vx-input-group-default flex-grow">
                            <div>
                              <div class="vs-component vs-con-input-label vs-input inputx vs-input-primary">
                                <div class="vs-con-input">
                                  <the-mask :masked="field.save_mask" :ref="`ref-${field.hash}`"
                                    :type="field.secret && !secretFields[field.hash]['visible'] ? 'password' : 'text'"
                                    autocomplete="new-password" :name="field.name" :placeholder="field.placeholder"
                                    v-model="fieldModel[field.hash]" :key="fieldsKeys[field.hash]"
                                    @focusout="handleFocusOut(field)" :disabled="isFieldDisabled(field)"
                                    :mask="['(##) ####-####', '(##) #####-####']" :value="''"
                                    class="vs-inputx vs-input--input normal need-style-placeholder"
                                    :maxlength="field.length || 524288" style="border: 1px solid rgba(0, 0, 0, 0.2);" />
                                </div>
                                <span></span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="vx-input-group flex mb-0"
                          v-else-if="field.mask && field.type_id !== $FIELD_TYPES.PHONE">
                          <div class="vx-input-group-default flex-grow">
                            <div>
                              <div class="vs-component vs-con-input-label vs-input inputx vs-input-primary">
                                <div class="vs-con-input">
                                  <the-mask :masked="field.save_mask" :ref="`ref-${field.hash}`"
                                    :type="field.secret && !secretFields[field.hash]['visible'] ? 'password' : 'text'"
                                    autocomplete="new-password" :name="field.name" :placeholder="field.placeholder"
                                    v-model="fieldModel[field.hash]" :key="fieldsKeys[field.hash]"
                                    @focusout="handleFocusOut(field)" :disabled="isFieldDisabled(field)"
                                    :mask="JSON.parse(JSON.stringify(field.mask)) || actionType === 'view'" :value="''"
                                    class="vs-inputx vs-input--input normal need-style-placeholder"
                                    :maxlength="field.length || 524288" style="border: 1px solid rgba(0, 0, 0, 0.2);" />
                                </div>
                                <span></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- END IF FIELD HAS MASK -->

                        <!-- :value="field.payload.split(' ')[0].split('-')[2] + '/' + field.payload.split(' ')[0].split('-')[1] + '/' + field.payload.split(' ')[0].split('-')[0] + ' ' + field.payload.split(' ')[1]" -->

                        <!-- START COMMON CONDITIONS -->
                        <div v-else>
                          <div>
                            <mask-field v-if="field.type_id === $FIELD_TYPES.INTEGER"
                            :type="field.secret && !secretFields[field.hash]['visible'] ? 'password' : 'text'"
                            :placeholder="field.placeholder"
                            :is-disabled="isFieldDisabled(field)"
                            v-model="fieldModel[field.hash]"
                            @focusout="onFieldChange($event, field)"
                            :mask="'##########'"
                            :maxlength="field.length || 524288"
                            />
                            <!-- <div class="vx-input-group flex mb-0" v-if="field.type_id === $FIELD_TYPES.INTEGER">
                              <div class="vx-input-group-default flex-grow">
                                <div>
                                  <div class="vs-component vs-con-input-label vs-input inputx vs-input-primary">
                                    <div class="vs-con-input">
                                      <the-mask :masked="field.save_mask" :ref="`ref-${field.hash}`"
                                        :type="field.secret && !secretFields[field.hash]['visible'] ? 'password' : 'text'"
                                        :placeholder="field.placeholder"
                                        :disabled="isFieldDisabled(field)"
                                        @focusout="handleFocusOut(field)" :key="fieldsKeys[field.hash]"
                                        :mask="'##########'" :value="''"
                                        class="vs-inputx vs-input--input normal need-style-placeholder"
                                        :maxlength="field.length || 524288"
                                        style="border: 1px solid rgba(0, 0, 0, 0.2);" />
                                    </div>
                                    <span></span>
                                  </div>
                                </div>
                              </div>
                            </div> -->
                            <!-- <ul v-else-if="field.type_id == $FIELD_TYPES.BOOLEAN" class="con-s w-full mb-2">
                              <li>
                                <vs-switch :ref="`ref-${field.hash}`"
                                  @input="onFieldChange($event, field)"
                                  v-model="fieldModel[field.hash]" :key="fieldsKeys[field.hash]"
                                  :disabled="isFieldDisabled(field)" class="mt-2" />
                              </li>
                            </ul> -->
                            <boolean-field
                              v-else-if="field.type_id == $FIELD_TYPES.BOOLEAN"
                              :key="fieldsKeys[field.hash]"
                              @input="onFieldChange($event, field)"
                              v-model="fieldModel[field.hash]" :isDisabled="isFieldDisabled(field)" />
                            <v-select
                              append-to-body
                              v-else-if="field.type_id == $FIELD_TYPES.PICKLIST && field.name == 'assigned_to_id'"
                              :clearable="false" :is-disabled="isFieldDisabled(field)"
                              :options="optionFieldModel[field.hash]" v-model="fieldModel[field.hash]"
                              :key="fieldsKeys[field.hash]" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                              <template v-slot:option="option">
                                <span v-if="option.groupLevel === 1"
                                  style="font-weight: bold!important; margin-left: -8px!important; cursor: default!important;"
                                  onclick="return">{{ $displayLabel(option, 'label') }}</span>
                                <span v-else>{{ $displayLabel(option, 'label') }}</span>
                              </template>
                              <template v-slot:selected-option="option">
                                <span>{{ option ? $displayLabel(option, 'label') : '' }}</span>
                              </template>
                            </v-select>


                            <v-select
                              v-else-if="field.type_id === $FIELD_TYPES.PICKLIST && field.name !== 'assigned_to_id'"
                              :ref="`ref-${field.hash}`" :clearable="!field.mandatory"
                              @input="onPicklistFieldChange($event, field.hash); onFieldChange($event, field)"
                              :disabled="isFieldDisabled(field)" :options="optionFieldModel[field.hash]"
                              v-model="fieldModel[field.hash]" :key="fieldsKeys[field.hash] + Math.random().toString()"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'">
                              <template v-slot:option="option">
                                <span>{{ $displayLabel(option, 'label') }}</span>
                              </template>
                              <template v-slot:selected-option="option">
                                <span>{{ option ? $displayLabel(option, 'label') : '' }}</span>
                              </template>
                            </v-select>


                            <!-- <v-select v-else-if="field.type_id === $FIELD_TYPES.MULTIPLE_LIST" multiple
                              :closeOnSelect="false" :clearable="!field.mandatory" :ref="`ref-${field.hash}`"
                              @input="onPicklistFieldChange($event, field.hash); onFieldChange($event, field);"
                              :disabled="isFieldDisabled(field)" :options="optionFieldModel[field.hash]"
                              v-model="fieldModel[field.hash]" :key="fieldsKeys[field.hash] + Math.random().toString()"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'" /> -->


                              <!-- <v-select v-else-if="field.type_id === $FIELD_TYPES.MULTIPLE_LIST" multiple
                              :closeOnSelect="false" :clearable="!field.mandatory" :ref="`ref-${field.hash}`"
                              @input="onPicklistFieldChange($event, field.hash); onFieldChange($event, field);"
                              :disabled="isFieldDisabled(field)" :options="optionFieldModel[field.hash]"
                              v-model="fieldModel[field.hash]" :key="fieldsKeys[field.hash] + Math.random().toString()"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'" /> -->

                              <!-- :disabled="isFieldDisabled(field)" -->
                              <v-select
                              v-else-if="field.type_id == $FIELD_TYPES.MULTIPLE_LIST && field.name == 'assigned_to_id_multiple'"
                              append-to-body
                              :clearable="false"
                              :options="optionFieldModel[field.hash]" v-model="fieldModel[field.hash]"
                              :key="fieldsKeys[field.hash]" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                              multiple>
                              <template v-slot:option="option">
                                <span v-if="option.groupLevel === 1"
                                  style="font-weight: bold!important; margin-left: -8px!important; cursor: default!important;"
                                  onclick="return">{{ $displayLabel(option, 'label') }}</span>
                                <span v-else>{{ $displayLabel(option, 'label') }}</span>
                              </template>
                              <template v-slot:selected-option="option">
                                <span>{{ option ? $displayLabel(option, 'label') : '' }}</span>
                              </template>
                            </v-select>

                              <select-field v-else-if="field.type_id === $FIELD_TYPES.MULTIPLE_LIST && field.name !== 'assigned_to_id_multiple'"
                              :ref="`ref-${field.hash}`"
                                multiple
                                :closeOnSelect="false"
                                :clearable="!field.mandatory"
                                @input="onPicklistFieldChange($event, field.hash); onFieldChange($event, field);"
                                :is-disabled="isFieldDisabled(field)"
                                :options="optionFieldModel[field.hash]"
                                v-model="fieldModel[field.hash]"
                                :key="fieldsKeys[field.hash] + Math.random().toString()"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'" />


                            <select-field :key="fieldsKeys[field.hash] + Math.random().toString()"
                              v-else-if="field.type_id == $FIELD_TYPES.RELATED_TO_A_MODULE || field.type_id == $FIELD_TYPES.RELATED_TO_KANBAN"
                              :isDisabled="isFieldDisabled(field) || dependentFieldDisableStatus[field.hash]"
                              :options="optionFieldModel[field.hash]" v-model="fieldModel[field.hash]"
                              @input="relatedModuleFieldChange(field.hash, $event); onFieldChange($event, field);" />


                            <select-field v-else-if="field.type_id == $FIELD_TYPES.RELATED_TO_A_USER"
                              :isDisabled="isFieldDisabled(field)"
                              :options="field.options" v-model="fieldModel[field.hash]"
                              @input="onFieldChange($event, field);" />


                            <!-- @input="relatedModuleFieldChange(field.hash, $event); field.call_api && onFieldChange($event, field.type_id, field.hash, field.minimal_timeout);" -->
                            <!-- :key="fieldsKeys[field.hash] + Math.random().toString()" -->


                            <v-select v-else-if="field.type_id == $FIELD_TYPES.PUSH_TAGS_LIST"
                              append-to-body
                              :ref="`ref-${field.hash}`" :key="fieldsKeys[field.hash]"
                              :disabled="isFieldDisabled(field) || dependentFieldDisableStatus[field.hash]"
                              :options="optionFieldModel[field.hash]" v-model="fieldModel[field.hash]" multiple taggable
                              push-tags :dir="$vs.rtl ? 'rtl' : 'ltr'" />


                            <!-- <v-select v-else-if="field.type_id === $FIELD_TYPES.RELATED_TO_A_MODULE_MULTIPLE"
                              multiple
                              :close-on-select="false"
                              :ref="`ref-${field.hash}`"
                              :disabled="isFieldDisabled(field) || dependentFieldDisableStatus[field.hash]"
                              :options="optionFieldModel[field.hash]"
                              v-model="fieldModel[field.hash]"
                              :key="fieldsKeys[field.hash] + Math.random().toString()"
                              @input="relatedModuleFieldChange(field.hash, $event); onFieldChange($event, field);"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'" /> -->

                            <select-field v-else-if="field.type_id === $FIELD_TYPES.RELATED_TO_A_MODULE_MULTIPLE"
                              multiple
                              :close-on-select="false"
                              :ref="`ref-${field.hash}`"
                              :is-disabled="isFieldDisabled(field) || dependentFieldDisableStatus[field.hash]"
                              :options="optionFieldModel[field.hash]"
                              v-model="fieldModel[field.hash]"
                              :key="fieldsKeys[field.hash] + Math.random().toString()"
                              @input="relatedModuleFieldChange(field.hash, $event); onFieldChange($event, field);"
                              @select-all="(newValue) => { fieldModel[field.hash] = newValue; onFieldChange(newValue, field); }"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'" />


                            <!-- <flat-pickr :ref="`ref-${field.hash}`" v-else-if="field.type_id === $FIELD_TYPES.DATE"
                            :placeholder="field.placeholder" :disabled="isFieldDisabled(field)"
                            v-model="fieldModel[field.hash]" :key="fieldsKeys[field.hash] + Math.random().toString()"
                            :value="fieldModel[field.hash]"
                            :config="{ dateFormat: 'd/m/Y', minDate: minValueMaxValueFields[field.hash]['minValue'], maxDate: minValueMaxValueFields[field.hash]['maxValue'] }"
                            class="w-full" name="dob" />

                          <flat-pickr :ref="`ref-${field.hash}`" v-else-if="field.type_id === $FIELD_TYPES.DATETIME"
                            @input="field.call_api && onFieldChange($event, field.type_id, field.hash, field.minimal_timeout)"
                            :placeholder="field.placeholder" :disabled="isFieldDisabled(field)"
                            v-model="fieldModel[field.hash]" :key="fieldsKeys[field.hash] + Math.random().toString()"
                            :value="fieldModel[field.hash]"
                            :config="{ enableTime: true, dateFormat: 'd/m/Y H:i:S', time_24hr: true, enableSeconds: true, maxDate: minValueMaxValueFields[field.hash]['maxValue'], minDate: minValueMaxValueFields[field.hash]['minValue'] }"
                            class="w-full" /> -->

                            <date-field
                              v-else-if="[$FIELD_TYPES.DATE, $FIELD_TYPES.DATETIME, $FIELD_TYPES.MULTIPLE_DATE].includes(field.type_id)"
                              :componentType="getDateComponentType(field.type_id)" :placeholder="field.placeholder"
                              :isDisabled="isFieldDisabled(field)" v-model="fieldModel[field.hash]"
                              :minValue="field.min_value" :maxValue="field.max_value" :allowPastDates="field.allow_past_dates"
                              @input="onFieldChange($event, field)"
                              />
                              <!--@onChange="onFieldChange($event, field)"-->


                            <div class="vx-input-group flex mb-0" v-if="field.type_id === $FIELD_TYPES.TIME">
                              <div class="vx-input-group-default flex-grow">
                                <div>
                                  <div class="vs-component vs-con-input-label vs-input inputx vs-input-primary">
                                    <div class="vs-con-input">
                                      <the-mask :masked="field.save_mask" :ref="`ref-${field.hash}`"
                                        :type="field.secret && !secretFields[field.hash]['visible'] ? 'password' : 'text'"
                                        autocomplete="new-password" :name="field.name" :placeholder="field.placeholder"
                                        :disabled="isFieldDisabled(field)" v-model="fieldModel[field.hash]"
                                        :key="fieldsKeys[field.hash]" :mask="'##:##:##'" :value="''"
                                        @focusout="handleFocusOut(field)"
                                        class="vs-inputx vs-input--input normal need-style-placeholder"
                                        :maxlength="field.length || 524288"
                                        style="border: 1px solid rgba(0, 0, 0, 0.2);" />
                                    </div>
                                    <span></span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- <vs-textarea v-else-if="field.type_id === 19" :disabled="!field.can_edit || field.is_disabled" style="height: 150px;!important" v-model="fieldModel[field.hash]" :key="fieldsKeys[field.hash]" :name="field.hash" :placeholder="field.placeholder" :maxlength="field.length ? field.length : 1000000" /> -->
                            <div data-v-13a23bd0="" v-else-if="field.type_id === $FIELD_TYPES.TEXTAREA"
                              class="vs-component vs-con-textarea vs-textarea-primary"
                              style="border: 1px solid rgba(0, 0, 0, 0.08)!important; "><!----><textarea
                                :disabled="isFieldDisabled(field)" style="height: 150px!important;" class="vs-textarea"
                                v-model="fieldModel[field.hash]" :key="fieldsKeys[field.hash]" :name="field.hash"
                                :placeholder="field.placeholder" @focusout="handleFocusOut(field)"
                                :maxlength="field.length ? field.length : 1000000"></textarea><!----></div>


                              <input v-if="field.type_id === $FIELD_TYPES.COLOR" type="color" class="inputx mt-1" placeholder="" v-model="fieldModel[field.hash]" />


                            <decimal-field
                              v-else-if="field.type_id === $FIELD_TYPES.PERCENTAGE || field.type_id === $FIELD_TYPES.DECIMAL"
                              v-model="fieldModel[field.hash]"
                              :isDisabled="isFieldDisabled(field)"
                              :value="fieldModel[field.hash]"
                              :placeholder="field.placeholder"
                              :type="field.secret && !secretFields[field.hash]['visible'] ? 'password' : 'tel'"
                              :moneyAttributes="decimalFields[field.hash]"
                              @focusout="handleFocusOut(field)"
                               />

                            <decimal-field v-else-if="field.type_id === $FIELD_TYPES.CURRENCY"
                              v-model="fieldModel[field.hash]" :isDisabled="isFieldDisabled(field)"
                              :placeholder="field.placeholder"
                              :value="fieldModel[field.hash]"
                              :type="field.secret && !secretFields[field.hash]['visible'] ? 'password' : 'tel'"
                              :moneyAttributes="currencyFields[field.hash]"
                              @focusout="handleFocusOut(field)" />

                            <GmapMap v-else-if="field.type_id == $FIELD_TYPES.MAP" :center="fieldModel[field.hash]"
                              :zoom="15" map-type-id="terrain" style="width: 100%; height: 400px">
                              <GmapMarker :position="fieldModel[field.hash]" :clickable="true" :draggable="true"
                                @click="center = fieldModel[field.hash]" />
                            </GmapMap>

                            <text-field v-else-if="normalFields.includes(field.type_id)"
                              v-model="fieldModel[field.hash]" :key="fieldsKeys[field.hash]"
                              :type="field.secret && !secretFields[field.hash]['visible'] ? 'password' : 'text'"
                              :maxLength="field.length || 524288" :placeholder="field.placeholder"
                              :isDisabled="isFieldDisabled(field) || Object.values(documentFieldModel).includes(field.hash)"
                              :name="field.name"
                              :cursor="field.type_id === $FIELD_TYPES.URL && !field.can_edit || field.is_disabled ? 'pointer' : 'default'"
                              @onTextFieldFocusOut="handleFocusOut(field)"
                              @onTextFieldClick="(field.type_id === $FIELD_TYPES.URL && (!field.can_edit || field.is_disabled)) ? onClickUrlField(field) : ''" />
                          </div>
                        </div>
                        <!-- END COMMON CONDITIONS -->
                      </div>
                    </vx-input-group>
                  </div>
                  <!-- END IF FIELD IS NOT IMAGE OR PHOTO-->
                  <small v-if="field.type_id !== $FIELD_TYPES.BADGE && field.type_id !== $FIELD_TYPES.TABLE && $i18n.locale !== 'en'"
                    id="textHelp1" class="form-text text-muted" style="display: block;">{{ field.subtitle }}</small>

                </div>
              </template>
            </div>
          </vx-card>
        </template>


      </div>
      <div class="vx-row" v-if="actionType !== 'view' && renderButton">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!submitButtonEnabled">{{ $t('MODULES.submit') }}</vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="danger"
              @click="$router.push($route.params.rowHash ? '/modules/' + $route.params.moduleHash : '/modules/view/' + $route.params.moduleHash)">{{ $t('MODULES.cancel') }}</vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="warning" icon-pack="feather" icon="icon-corner-up-left"
              @click="$router.go(-1)">{{ $t('MODULES.back') }}</vs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import StringMask from 'string-mask'
import RelatedModuleTable from '../../components/custom-modules/RelatedModuleTable.vue'
import { Edit2Icon, CheckIcon, XIcon, EyeIcon, EyeOffIcon, CheckCircleIcon, FacebookIcon, YoutubeIcon, Link2Icon, TwitterIcon, LinkedinIcon, InstagramIcon, PhoneIcon, CalendarIcon, MailIcon, FileIcon, ClockIcon, SlackIcon, PercentIcon, DollarSignIcon, Trash2Icon } from 'vue-feather-icons'
import vSelect from 'vue-select'
import myUpload from 'vue-image-crop-upload'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import ItemsModuleModal from './ItemsModuleModal.vue'
import ItemsModuleTable from './ItemsModuleTable.vue'
import { setApplicationLocalStorageItem, getApplicationLocalStorageItem, removeApplicationLocalStorageItem, performFetch } from '../../helpers'
import TextField from '../custom-fields/TextField.vue'
import DecimalField from '../custom-fields/DecimalField.vue'
import SelectField from '../custom-fields/SelectField.vue'
import DocumentField from '../custom-fields/DocumentField.vue'
import MultipleDocumentField from '../custom-fields/MultipleDocumentField.vue'
import DateField from '../custom-fields/DateField.vue'
import MaskField from '../custom-fields/MaskField.vue'
import BooleanField from '../custom-fields/BooleanField.vue'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'


export default {
  components: {
    quillEditor,
    SelectField,
    DecimalField,
    TextField,
    Edit2Icon,
    CheckIcon,
    EyeIcon,
    EyeOffIcon,
    XIcon,
    PhoneIcon,
    Link2Icon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    YoutubeIcon,
    FacebookIcon,
    CalendarIcon,
    MailIcon,
    FileIcon,
    ClockIcon,
    SlackIcon,
    PercentIcon,
    DollarSignIcon,
    Trash2Icon,
    vSelect,
    'my-upload': myUpload,
    flatPickr,
    ItemsModuleModal,
    ItemsModuleTable,
    DocumentField,
    DateField,
    RelatedModuleTable,
    MaskField,
    BooleanField,
    MultipleDocumentField
  },
  props: {
    blockTabs: {
      type: Object,
      default: () => {}
    },
    delegatorUrl: {
      type: String,
      default: ''
    },
    actionType: {
      type: String,
      required: true
    },
    detailProp: {
      type: Object,
      default: {}
    },
    blockDataProp: {
      type: Array,
      required: true
    },
    permissionsProp: {
      type: Object,
      required: true
    },
    enableEditProp: {
      type: Object,
      required: true
    },
    renderButton: {
      type: Boolean,
      default: true
    },
    relatedReadOnly: {
      type: Boolean,
      default: false
    }
  },
  // directives: { money: Money },
  watch: {
    // Inclui iframe submit ready; Edit.vue usa renderButton=false e o botão Salvar do pai
    // escuta só este evento — precisa do estado completo, não só canSaveForm.
    submitButtonEnabled: {
      handler (val) {
        this.$emit('onCanSaveFormChange', val)
      },
      immediate: true
    },
    'optionFieldModel': {
      handler (newVal) {
        try {
          const relatedModuleRowHash = this.$route.params.relatedModuleRowHash
          const relatedModuleFieldHash = this.$route.params.relatedModuleFieldHash
          if (this.optionFieldModel.hasOwnProperty(relatedModuleFieldHash) && this.pageLoaded === false && this.actionType === 'add') {
            if (relatedModuleRowHash !== undefined && relatedModuleFieldHash !== undefined) {

              if (Array.isArray(this.optionFieldModel[relatedModuleFieldHash])) {
                const rowOption = this.optionFieldModel[relatedModuleFieldHash].find(x => x.value === relatedModuleRowHash)

                this.fieldModel[relatedModuleFieldHash] = rowOption

                // this.showFieldsModel[relatedModuleFieldHash] = false

                this.relatedModuleFieldChange(relatedModuleFieldHash, rowOption)
              }
            }
          }
          this.pageLoaded = true
        } catch (e) {
          // console.error('Error in optionFieldModel watcher:', e);
        }


        // this.$emit('onOptionFieldModelChange', newVal)
      },
      deep: true
    },
    blockDataProp () {
      this.blocks = JSON.parse(JSON.stringify(this.blockDataProp))
      this.blocksOriginal = JSON.parse(JSON.stringify(this.blockDataProp))
      this.detail = JSON.parse(JSON.stringify(this.detailProp))
      this.permissions = JSON.parse(JSON.stringify(this.permissionsProp))
      this.enableEdit = JSON.parse(JSON.stringify(this.enableEditProp))
      this.dependentFieldsInitialized = false
      this.setBlocks()
      if (this.permissions.can_edit) {
        try {
          const el = document.querySelector('#edit_button')
          el.parentNode.removeChild(el)
        } catch (e) {
          //
        }
      } else {
        try {
          const el = document.querySelector('#edit_button')
          el.parentNode.removeChild(el)
        } catch (e) {
          //
        }
      }
      this.updateQuillEditors()
    },
    actionType () {
      this.updateQuillEditors()
    },
    detailProp () {
      this.detail = this.detailProp
    }
  },
  data () {
    return {
      canSaveForm: true,
      tablesFieldsList: [],
      moduleItemsModel: {},
      selectedRows: {},
      moduleItemsTitlesModel: {},
      moduleItemsFields: {},
      modalData: [],
      itemsModalActive: false,
      itemsModuleFieldsProperties: {},
      currentItemsFieldHash: '',
      itemsModalTitle: 'Adicionar',
      currentItemsAction: 'add',
      currentItemIndex: null,
      itemsDataModel: {},
      currentFormData: {},
      selectedItemsRows: {},
      tableHashFields: {},
      tableItemsToDelete: {},
      listItemsIndex: [],
      fieldsKeys: {},
      documentFieldModel: {},
      documentUploadsPending: 0,
      embbededFields: [],


      dependentFieldOptions: {},
      dependentFieldDisableStatus: {},
      childFields: {},
      viewMode: {},
      secretFields: {},
      showEmptyDataMessage: false,
      show: {},
      fieldModel: {},
      newDocuments: {},
      dataFieldPayload: {},
      dataFieldPayloadLabel: {},
      blocks: [],
      detail: {},
      permissions: {},
      optionFieldModel: {},
      enableEdit: {},
      decimalFields: {},
      currencyFields: {},
      mandatoryFields: [],
      fieldName: {},
      fieldTitle: {},
      fieldType: {},
      hoverImageList: {},
      minValueMaxValueFields: {},
      normalFields: [1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 14, 15],
      specialFields: [2, 12, 13, 16, 17, 18, 19, 20, 21, 22, 23],
      textFields: [1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 14, 15, 16, 17, 18, 19, 20],
      floatFields: [2, 16, 18, 20],
      objectFields: [24, 25, 29, 30],
      uploadFields: [21, 22, 27, 28],
      dateFields: [12],
      dateTimeFields: [13],
      booleanFields: [23],
      refFields: [2, 3, 16, 17, 18, 20, 12, 13],
      keyPicklistItems: {},
      refFieldsFireStatus: {},
      matchPatternFields: {},
      isFrameLoading: {},
      loadedFrames: [],
      pageLoaded: false,
      dependentFieldsInitialized: false,
      iframeSubmitReadyByHash: {}
    }
  },
  mounted () {
    window.addEventListener('message', this.handleIframeMessage)
  },
  beforeDestroy () {
    window.removeEventListener('message', this.handleIframeMessage)
  },
  created () {

    this.fieldModel = JSON.parse(JSON.stringify({}))


  },
  updated () {
    this.updateQuillEditors()
  },
  computed: {
    submitButtonEnabled () {
      if (!this.canSaveForm) {
        return false
      }
      for (const b of this.blocks) {
        if (b.content_type === 'embbeded' && b.require_iframe_submit_ready) {
          if (this.iframeSubmitReadyByHash[b.hash] !== true) {
            return false
          }
        }
      }
      return true
    }
  },
  methods: {
    handleIframeMessage (event) {
      let payload = event.data
      if (typeof payload === 'string') {
        try {
          payload = JSON.parse(payload)
        } catch (e) {
          return
        }
      }
      if (!payload || typeof payload !== 'object' || payload.event === undefined) {
        return
      }

      if (payload.event === 'iframeHeight') {
        const novaAltura = payload.height
        const iframeId = payload.iframeId
        const iframe = this.$refs[`iframe-${iframeId}`][0]

        if (iframe) {
          iframe.style.height = `${novaAltura}px`
        }
      } else if (payload.event === 'iframeUpdated') {
        const iframeId = payload.iframeId
        const data = payload.data

        try {
          this.communicateEmbbededFields({'event': 'iframeUpdated', iframeId, data})
        } catch (e) {
        }


      } else if (payload.event === 'iframeSubmitReady') {
        console.log('[VISE Studio] Recebido evento iframeSubmitReady', {
          iframeId: payload.iframeId,
          ready: payload.ready
        })
        const iframeId = payload.iframeId
        if (iframeId != null && this.embbededFields.includes(iframeId)) {
          this.$set(this.iframeSubmitReadyByHash, iframeId, payload.ready === true)
        }
      } else if (payload.event === 'notification') {
        const notifyOpts = {
          title: payload.title,
          text: payload.message,
          iconPack: 'feather',
          icon: 'icon-bell',
          color: payload.color,
          position: 'top-center',
          time: payload.time || 5000
        }
        if (payload.fixed === true) {
          notifyOpts.fixed = true
        }
        this.$vs.notify(notifyOpts)
      } else if (payload.event === 'get_current_state') {
        const iframeId = payload.iframeId
        this.communicateEmbbededFields({'event': 'currentState', iframeId, 'rowState': this.fieldModel})
      } else if (payload.event === 'iframeError') {
        console.error('Error loading iframe:', payload.error)

      } else if (payload.event === 'iframeLoaded') {
        // this.$vs.loading.close('#div-with-loading > .con-vs-loading')
      }
    },
    onRelatedTabChange (event) {
      if (event.tabData.callApi) {
        try {
          this.communicateEmbbededFields(event)
        } catch (e) {
        }
      }
    },
    communicateEmbbededFields (data) {
      data.moduleHash = this.$route.params.moduleHash
      // data.rowHash = null;
      if (!data.hasOwnProperty('rowHash')) {
        data.rowHash = this.$route.params.rowHash ? this.$route.params.rowHash : null
      }

      if (!('rowState' in data)) {
        data.rowState = this.fieldModel
      }

      for (const field of this.embbededFields) {
        try {
          const iframe = this.$refs[`iframe-${field}`][0]
          if (this.loadedFrames.includes(`iframe-${field}`)) {
            iframe.contentWindow.postMessage(JSON.stringify(data), '*')
          }
        } catch (e) {
          console.error('error communicating embbeded fields', e)
        }
      }
    },
    beforeFrameLoad (url) {

      return url
    },
    async onFrameLoad (refId, blockTitle) {

      this.loadedFrames.push(refId)

      const iframe = this.$refs[refId][0]

      while (!iframe) {
        await new Promise(resolve => setTimeout(resolve, 200))
      }

      iframe.contentWindow.postMessage(JSON.stringify({
        event: 'page_loaded',
        rowHash: this.$route.params.rowHash,
        rowState: this.fieldModel,
        actionType: this.actionType
      }), '*')
    },
    getDateComponentType (field_type_id) {
      switch (field_type_id) {
      case this.$FIELD_TYPES.DATE:
        return 'date'

      case this.$FIELD_TYPES.DATETIME:
        return 'datetime'

      case this.$FIELD_TYPES.MULTIPLE_DATE:
        return 'multiple_date'

      default:
        return 'date'
      }
    },
    clearPushTagsOptions (fieldHash) {
      this.$set(this.fieldModel, fieldHash, [])
      this.$set(this.optionFieldModel, fieldHash, [])
      this.$set(this.fieldsKeys, fieldHash, `${fieldHash}-${Math.random()}`)
      //  = [];
      // this.optionFieldModel[fieldHash] = [];
    },
    isFieldDisabled (field) {
      if (!field.can_edit || field.is_disabled || field.is_disabled || this.actionType === 'view') {
        return true
      } else {
        return false
      }
    },
    updateQuillEditors () {
      this.$nextTick(() => {
        const richtextFields = []
        this.blocks.forEach(block => {
          if (block.fieldList && Array.isArray(block.fieldList)) {
            block.fieldList.forEach(fieldGroup => {
              if (Array.isArray(fieldGroup)) {
                fieldGroup.forEach(field => {
                  if (field.type_id === this.$FIELD_TYPES.RICHTEXT) {
                    richtextFields.push(field)
                  }
                })
              }
            })
          }
        })

        richtextFields.forEach(field => {
          const refName = `quill-editor-${field.hash}`
          const quillComponent = this.$refs[refName]

          const quillRef = Array.isArray(quillComponent) ? quillComponent[0] : quillComponent

          if (quillRef && quillRef.quill) {
            const isDisabled = this.isFieldDisabled(field)
            quillRef.quill.enable(!isDisabled)

            let toolbarElement = null
            if (quillRef.$el) {
              toolbarElement = quillRef.$el.querySelector('.ql-toolbar')

              if (!toolbarElement && quillRef.$el.parentElement) {
                toolbarElement = quillRef.$el.parentElement.querySelector('.ql-toolbar')
              }

              if (!toolbarElement && quillRef.$el.closest) {
                const richtextContainer = quillRef.$el.closest('.richtext-field')
                if (richtextContainer) {
                  toolbarElement = richtextContainer.querySelector('.ql-toolbar')
                }
              }
            }

            if (toolbarElement) {
              if (isDisabled) {
                const toolbarButtons = toolbarElement.querySelectorAll('button, select, .ql-picker, .ql-picker-label, .ql-picker-options')
                toolbarButtons.forEach(element => {
                  element.style.pointerEvents = 'none'
                  element.style.opacity = '0.5'
                  element.style.cursor = 'not-allowed'
                  if (element.tagName === 'BUTTON' || element.tagName === 'SELECT') {
                    element.disabled = true
                  }
                })
                toolbarElement.style.opacity = '0.5'
                toolbarElement.style.pointerEvents = 'none'
                toolbarElement.style.cursor = 'not-allowed'
              } else {
                const toolbarButtons = toolbarElement.querySelectorAll('button, select, .ql-picker, .ql-picker-label, .ql-picker-options')
                toolbarButtons.forEach(element => {
                  element.style.pointerEvents = ''
                  element.style.opacity = ''
                  element.style.cursor = ''
                  if (element.tagName === 'BUTTON' || element.tagName === 'SELECT') {
                    element.disabled = false
                  }
                })
                toolbarElement.style.opacity = ''
                toolbarElement.style.pointerEvents = ''
                toolbarElement.style.cursor = ''
              }
            }
          }
        })
      })
    },
    onMassDeleteItems (fieldHash) {
      for (const item of this.selectedItemsRows[fieldHash]) {
        const itemIndex = this.fieldModel[fieldHash].findIndex(x => JSON.stringify(x) === JSON.stringify(item))

        if (itemIndex > -1) {
          this.fieldModel[fieldHash].splice(itemIndex, 1)
        }
      }
    },
    normalizeTableFieldData (tableData) {

      const normalizedTableData = []

      for (const record of tableData) {

        const normalizedRecord = {}

        Object.entries(record).forEach((recordItem) => {

          const fieldHash = recordItem[0]
          let fieldPayload = recordItem[1]

          switch (this.fieldType[fieldHash]) {

          case 12:

            if (fieldPayload !== null && fieldPayload !== '') {
              normalizedRecord[fieldHash] = `${fieldPayload.split('/')[2]}-${fieldPayload.split('/')[1]}-${fieldPayload.split('/')[0]}`
            }

            break


          case 13:

            if (fieldPayload !== null && fieldPayload !== '') {

              const date = fieldPayload.split(' ')[0]
              const time = fieldPayload.split(' ')[1]

              normalizedRecord[fieldHash] = `${date.split('/')[2]}-${date.split('/')[1]}-${date.split('/')[0]} ${time}`
            }

            break


          case 18:

            if (fieldPayload !== null && fieldPayload !== '') {

              fieldPayload = fieldPayload.replace('R$ ', '')

              fieldPayload = fieldPayload.replace('.', '')

              fieldPayload = fieldPayload.replace(',', '.')

              normalizedRecord[fieldHash] = parseFloat(fieldPayload)
            }

            break

          case 24:
          case 25:
          case 29:
          case 30:

            const normalizedValue = this.optionFieldModel[fieldHash].find(x => x.label === fieldPayload)

            if (normalizedValue !== null && normalizedValue !== undefined) {
              normalizedRecord[fieldHash] = normalizedValue.value
            }

            break


          default:

            if (this.itemsModuleFieldsProperties[fieldHash].mask) {
              if (fieldPayload !== null && fieldPayload !== '') {
                normalizedRecord[fieldHash] = fieldPayload.replace(/[^\w]/gi, '')
              } else {
                normalizedRecord[fieldHash] = fieldPayload
              }
            } else {
              normalizedRecord[fieldHash] = fieldPayload
            }

          }

        })

        normalizedTableData.push(normalizedRecord)

      }

      return normalizedTableData
    },
    onClickUrlField (fieldObject) {
      if (fieldObject.payload !== null && fieldObject.payload !== '') {
        if (fieldObject.payload.charAt(0) === '/') {
          this.$router.push(fieldObject.payload)
        } else {
          window.open(fieldObject.payload, '_blank')
        }
      }
    },
    onModuleItemsSelectedRowsChanged (value) {
      value = JSON.parse(value)
      const fieldHash = value['fieldHash']
      value = value['value']

      this.selectedItemsRows[fieldHash] = value
    },
    onDeleteItem (index, fieldHash) {
      const $item = JSON.parse(JSON.stringify(this.fieldModel[fieldHash][index]))
      $item['to_delete'] = true
      this.tableItemsToDelete[fieldHash].push($item)
      this.fieldModel[fieldHash].splice(index, 1)
    },
    onSubmitItem (formData, fieldHash) {

      if (this.currentItemsAction === 'add') {

        const formDataArr = Array(this.listItemsIndex[fieldHash].length + 1).fill(null)

        Object.entries(formData).forEach((value, key) => {
          if (key === 0) {
            formDataArr[0] = value
          } else {
            formDataArr[this.listItemsIndex[fieldHash].findIndex(x => x === value[0]) + 1] = value
          }
        })

        this.updateItemsList(formDataArr, fieldHash, formData)

      } else {

        // const formDataArr = Object.entries(formData)

        const formDataArr = Array(this.listItemsIndex[fieldHash].length + 1).fill(null)

        Object.entries(formData).forEach((value, key) => {
          if (key === 0) {
            formDataArr[0] = value
          } else {
            formDataArr[this.listItemsIndex[fieldHash].findIndex(x => x === value[0]) + 1] = value
          }
        })

        this.updateItemsList(formDataArr, fieldHash, formData, this.currentItemIndex)

      }

    },
    onEditItem (itemIndex, fieldHash) {

      this.buildItemsModal(fieldHash, this.itemsDataModel[fieldHash][itemIndex], itemIndex)
    },
    onAddItem (fieldHash) {
      this.currentItemsAction = 'add'
      this.itemsModalTitle = 'Adicionar'
      this.currentItemIndex = null
      this.currentFormData = {}
      this.buildItemsModal(fieldHash)
    },
    buildItemsModal (fieldHash, formData = {}, itemIndex = null) {

      this.modalData = JSON.parse(JSON.stringify(this.moduleItemsFields[fieldHash]))

      this.currentItemsFieldHash = fieldHash

      this.itemsModalActive = true

      if (JSON.stringify(formData) !== '{}' && itemIndex !== null) {
        this.currentFormData = formData

        this.currentItemsAction = 'edit'

        this.itemsModalTitle = 'Editar'

        this.currentItemIndex = itemIndex
      }

    },
    updateItemsList (formDataArr, fieldHash, formDataRaw, currentItemIndex = null) {

      const newRow = {}

      for (const fieldModelItem of formDataArr) {
        const fieldKey = fieldModelItem[0]
        const fieldValue = fieldModelItem[1]

        const fieldProperties = this.itemsModuleFieldsProperties[fieldKey]

        let fieldListPayload = null

        if (fieldValue !== null && fieldValue !== '') {
          // if (fieldProperties.type_id === 12) {

          //   const dateObject = new Date(fieldValue)

          //   const year = dateObject.getFullYear()
          //   let month = dateObject.getMonth() + 1

          //   if (month < 10) {
          //     month = '0' + month
          //   }

          //   let day = dateObject.getDate()

          //   if (day < 10) {
          //     day = '0' + day
          //   }

          //   fieldListPayload = `${day}/${month}/${year}`
          // } else if (fieldProperties.type_id === 13) {
          //   if (fieldValue !== null && fieldValue !== '') {

          //     let date = fieldValue.split(' ')[0]
          //     let time = fieldValue.split(' ')[1]

          //     fieldListPayload = `${date.split('-')[2]}/${date.split('-')[1]}/${date.split('-')[0]} ${time}`
          //   }
          // }
          if (fieldProperties.type_id === 16 || fieldProperties.type_id === 18 || fieldProperties.type_id === 20) {

            const showProgressBar = fieldProperties.show_progress_bar

            let config = null

            if (fieldProperties.type_id === 16 || fieldProperties.type_id === 20) {
              config = { minimumFractionDigits: fieldProperties.decimals, maximumFractionDigits: fieldProperties.decimals }
            } else {
              config = { style: 'currency', currency: 'BRL', minimumFractionDigits: fieldProperties.decimals, maximumFractionDigits: fieldProperties.decimals }
            }

            const value = parseFloat(fieldValue)

            if (!isNaN(value)) {
              fieldListPayload = parseFloat(fieldValue).toLocaleString('pt-BR', config)

              if (fieldProperties.type_id === 16) {
                if (showProgressBar) {
                  fieldListPayload = `${fieldValue  }%%`
                } else {
                  fieldListPayload = `${fieldValue  }%`
                }
              }
            } else {
              fieldListPayload = null
            }

          } else if (fieldProperties.type_id === 19) {

            if (fieldValue && fieldListPayload.length > 50) {
              fieldValue = `${fieldListPayload.substr(0, 50)  }...`
            } else {
              fieldValue = fieldListPayload
            }

          } else if (fieldProperties.type_id === 24 || fieldProperties.type_id === 25 || fieldProperties.type_id === 29 || fieldProperties.type_id === 30) {

            if (fieldValue !== null && JSON.stringify(fieldValue) !== '{}') {
              if ('value' in fieldValue) {
                fieldListPayload = fieldValue.label
              }
            }

          } else if (fieldProperties.mask) {

            if (fieldProperties.type_id === 3) {

              if (fieldValue !== null && fieldValue.length === 10) {
                const formatter = new StringMask('(##) ####-####')
                const result = formatter.apply(fieldValue)

                fieldListPayload = result
              } else if (fieldValue !== null && fieldValue.length === 11) {
                const formatter = new StringMask('(##) #####-####')
                const result = formatter.apply(fieldValue)

                fieldListPayload = result
              } else {
                const formatter = new StringMask(fieldProperties.mask)
                const result = formatter.apply(fieldValue)

                fieldListPayload = result
              }
            } else {
              const formatter = new StringMask(fieldProperties.mask)
              const result = formatter.apply(fieldValue)

              fieldListPayload = result
            }

          } else {
            fieldListPayload = fieldValue
          }
        }

        newRow[fieldProperties.hash] = fieldListPayload
      }

      if (currentItemIndex === null) {
        const itemIndex = this.fieldModel[fieldHash].push(newRow) - 1
        this.$set(this.itemsDataModel[fieldHash], itemIndex, JSON.parse(JSON.stringify(formDataRaw)))
      } else {
        this.fieldModel[fieldHash][currentItemIndex] = newRow
        this.itemsDataModel[fieldHash][currentItemIndex] = JSON.parse(JSON.stringify(formDataRaw))
      }

      const moduleItemsTemp = JSON.parse(JSON.stringify(this.fieldModel[fieldHash]))
      this.fieldModel[fieldHash] = []
      this.fieldModel[fieldHash] = moduleItemsTemp

    },
    setIsModalActive (value) {
      this.itemsModalActive = value
    },
    fieldIsVisible (picklistHash, picklistItemHash) {
      if (picklistHash !== null && picklistHash !== undefined) {
        const picklistItems = this.keyPicklistItems[picklistHash]
        if (!picklistItems || picklistItemHash === null || picklistItemHash === undefined) {
          return false
        }
        return !!picklistItems[picklistItemHash]
      }
      return true
    },
    blockIsVisible (picklistHash, picklistItemHash, showOnAdd) {

      if (this.actionType === 'add' && !showOnAdd) {
        return false
      }

      if (Array.isArray(picklistHash) && picklistHash.length === 0) {
        return true
      }

      if (picklistHash === null || picklistHash === undefined) {
        return true
      }

      const allItems = []

      if (Array.isArray(picklistHash) && Array.isArray(picklistItemHash)) {
        let i = 0
        for (const value of picklistHash) {
          const picklistItems = this.keyPicklistItems[value.hash]
          const itemHash = picklistItemHash[i] && picklistItemHash[i].hash
          if (!picklistItems || !itemHash) {
            return false
          }
          allItems.push(!!picklistItems[itemHash])
          i++
        }
      }

      if (allItems.length > 0) {
        return allItems.every(item => item === true)
      }

      return false
    },
    onPicklistFieldChange (event, fieldHash) {

      Object.keys(this.keyPicklistItems[fieldHash]).forEach(picklistItemHash => {
        this.keyPicklistItems[fieldHash][picklistItemHash] = false
      })

      if (event !== null) {
        if (event.value !== 0) {
          this.keyPicklistItems[fieldHash][event.value] = true
        }
      }

      this.setBlocks(true)

    },
    validateTextFields (data) {

      if (typeof data === 'number' || typeof data === 'boolean') {
        data = data.toString()
      }

      if (typeof data !== 'string') {
        return { dataValidated: false, fieldValue: '' }
      }

      return { dataValidated: true, fieldValue: data }
    },
    validateFloatFields (data) {

      if (!isNaN(data)) {
        return { dataValidated: true, fieldValue: parseFloat(data) }
      } else {
        return { dataValidated: false, fieldValue: 0 }
      }

    },
    validateObjectFields (fieldHash, data) {

      let fieldOptions = null

      if (this.optionFieldModel.hasOwnProperty(fieldHash)) {
        fieldOptions = this.optionFieldModel[fieldHash]
      }

      if (fieldOptions !== null) {
        const reg = /^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i

        const isUuid = data.match(reg)

        if (isUuid === null) {
          data = fieldOptions.find(x => x.value === 0)
          return { dataValidated: true, fieldValue: data }
        } else {

          data = fieldOptions.find(x => x.value === data)

          if (data === undefined) {
            data = fieldOptions.find(x => x.value === 0)
          }
        }
      } else {
        return { dataValidated: false, fieldValue: {} }
      }

      return { dataValidated: true, fieldValue: data }
    },
    validateDateFields (data) {

      const isDate = this.checkIfStringIsDateDashFormat(data)

      if (isDate) {
        data = `${data.split('-')[2]}/${data.split('-')[1]}/${data.split('-')[0]}`
      } else {
        data = ''
      }

      return { dataValidated: true, fieldValue: data }
    },
    validateDatetimeFields (data) {

      const isDateTime = this.checkIfStringIsDateTimeDashFormat(data)

      if (isDateTime) {
        data = `${data.split(' ')[0].split('-')[2]}-${data.split(' ')[0].split('-')[1]}-${data.split(' ')[0].split('-')[0]} ${data.split(' ')[1]}`
      } else {
        data = ''
      }

      return { dataValidated: true, fieldValue: data }
    },
    validateBooleanFields (data) {

      if (typeof data !== 'boolean') {
        data = false
      }

      return { dataValidated: true, fieldValue: data }
    },
    async onFieldChange (event, field) {

      if (field.call_api) {
        const { type_id, hash, minimal_timeout } = field

        const fieldTypeId = type_id
        const fieldHash = hash
        const fieldMinimalTimeout = minimal_timeout

        let fieldData = null

        if (event instanceof FocusEvent) {
          event = event.target.value
        } else {
          fieldData = event
        }

        switch (fieldTypeId) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13:
        case 35:

          fieldData = event

          break

        case 14:
        case 15:
        case 16:
        case 17:
        case 18:
        case 19:
        case 20:
        case 23:

          if (event !== null && typeof event === 'object' && event.target) {
            event = event.target.value
          }

          fieldData = event

          break

        case 24:
        case 25:
        case 30:

          if (event !== null && typeof event === 'object' && event.hasOwnProperty('value') && event.value !== 0) {
            fieldData = event['value']
          } else {
            fieldData = null
          }

          break
        }

        this.$vs.loading({ type: 'default' })
        try {
          this.communicateEmbbededFields({'event': 'delegator', 'fieldHash': field.hash, fieldData, 'rowState': this.fieldModel})
        } catch (e) {
        }
        await this.callFieldApiExec(fieldData, field.hash, fieldMinimalTimeout)

        this.$vs.loading.close()
      }
    },
    async callFieldApiExec (fieldData, fieldHash, minimalTimeout, isDocument = false) {

      minimalTimeout = minimalTimeout * 1000

      return new Promise(async (resolve) => {

        const controller = new AbortController()
        const id = setTimeout(() => controller.abort(), minimalTimeout)

        const requestData = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            command: 'get_field_data',
            application_token: this.$store.state.auth.app_token,
            module_token: this.$route.params.moduleHash,
            api_token: this.detail.api_token,
            parameters: {
              field: {
                hash: fieldHash,
                payload: fieldData
              },
              row_payload: await this.buildRowData(this.fieldModel, this.fieldType, this.fieldName)
            }
          })
        }

        if (isDocument) {
          requestData['timeout'] = minimalTimeout
          requestData['signal'] = controller.signal
        }

        await fetch(`${this.detail.api_delegator}`, requestData)
          .then(async (response) => {
            let messageColor = 'success'
            let messageIcon = 'icon-check-circle'
            let messageTitle = 'Operação Realizada!'
            if (response.status.toString().charAt(0) === '4') {
              messageColor = 'warning'
              messageIcon = 'icon-alert-circle'
            } else if (response.status.toString().charAt(0) === '5') {
              messageColor = 'danger'
              messageIcon = 'icon-alert-circle'
            }
            response.json().then(responseData => {
              if (responseData.message !== null) {
                if(responseData.hasOwnProperty('messageColor')) {
                  messageColor = responseData.messageColor
                }
                if(responseData.hasOwnProperty('messageTitle')) {
                  messageTitle = responseData.messageTitle
                }
                if(responseData.hasOwnProperty('messageIcon')) {
                  messageIcon = responseData.messageIcon
                }

                this.$vs.notify({
                  title: messageTitle,
                  text: responseData.message,
                  iconPack: 'feather',
                  icon: messageIcon,
                  color: messageColor
                })
              }

              if (response.status === 200) {

                if (responseData.hasOwnProperty('payload')) {

                  if (responseData.payload.hasOwnProperty('canSave')) {
                    console.log('canSave: ' + responseData.payload.canSave)
                    console.log('typeof canSave: ' + typeof responseData.payload.canSave)
                    const rawCanSave = responseData.payload.canSave
                    if (typeof rawCanSave === 'string') {
                      const normalized = rawCanSave.trim().toLowerCase()
                      this.canSaveForm = normalized === 'true' || normalized === '1'
                    } else {
                      this.canSaveForm = Boolean(rawCanSave)
                    }
                  }

                  Object.keys(responseData.payload).forEach(fieldHash => {
                    const fieldTypeId = this.fieldType[fieldHash]
                    let fieldValue = responseData.payload[fieldHash]

                    let dataValidated = false

                    if (this.textFields.includes(fieldTypeId)) {
                      const validateDataReturn = this.validateTextFields(fieldValue)
                      dataValidated = validateDataReturn.dataValidated
                      fieldValue = validateDataReturn.fieldValue
                    } else if (this.floatFields.includes(fieldTypeId)) {
                      const validateDataReturn = this.validateFloatFields(fieldValue)
                      dataValidated = validateDataReturn.dataValidated
                      fieldValue = validateDataReturn.fieldValue
                    } else if (this.objectFields.includes(fieldTypeId)) {
                      const validateDataReturn = this.validateObjectFields(fieldHash, fieldValue)
                      dataValidated = validateDataReturn.dataValidated
                      fieldValue = validateDataReturn.fieldValue
                      fieldValue = JSON.parse(JSON.stringify(fieldValue))
                      fieldValue['selected'] = true
                    } else if (this.uploadFields.includes(fieldTypeId)) {
                      //
                    } else if (this.dateFields.includes(fieldTypeId)) {
                      const validateDataReturn = this.validateDateFields(fieldValue)
                      dataValidated = validateDataReturn.dataValidated
                      fieldValue = validateDataReturn.fieldValue
                    } else if (this.dateTimeFields.includes(fieldTypeId)) {
                      const validateDataReturn = this.validateDatetimeFields(fieldValue)
                      dataValidated = validateDataReturn.dataValidated
                      fieldValue = validateDataReturn.fieldValue
                    } else if (this.booleanFields.includes(fieldTypeId)) {
                      const validateDataReturn = this.validateBooleanFields(fieldValue)
                      dataValidated = validateDataReturn.dataValidated
                      fieldValue = validateDataReturn.fieldValue
                    }

                    if (dataValidated) {
                      // console.log('data validated!')
                      // console.log('new value: ' + JSON.stringify(fieldValue))
                      // this.fieldModel[fieldHash] = 0
                      // setTimeout(() => {
                      // this.$set(this.fieldModel, fieldHash, fieldValue)
                      // }, 300)

                      if (this.fieldType[fieldHash] === 24 && this.fieldName[fieldHash] !== 'assigned_to_id') {
                        this.fieldModel[fieldHash] = fieldValue
                        this.onPicklistFieldChange(fieldValue, fieldHash)
                      } else if (this.fieldType[fieldHash] === 25) {
                        this.fieldModel[fieldHash] = fieldValue
                        this.relatedModuleFieldChange(fieldHash, fieldValue)
                      } else {
                        this.fieldModel[fieldHash] = fieldValue
                        this.fieldsKeys[fieldHash] = (Math.random() + 1).toString(36).substring(2)
                      }
                    }
                  })
                }

                if (responseData.hasOwnProperty('next_focus')) {
                  const nextFocus = this.$refs[`ref-${responseData.next_focus}`]

                  if (nextFocus !== undefined) {
                    try {
                      nextFocus[0].$el.focus()
                    } catch (e) {
                      //
                    }
                  }
                }
              }

              this.refFieldsFireStatus[fieldHash] = false
              resolve(true)
            })
          })
          .catch((e) => {
            console.log(e)
            this.refFieldsFireStatus[fieldHash] = false
            resolve(true)
          })

        clearTimeout(id)
      })
    },
    openDocument (event, documentUrl) {
      if (event.target.textContent !== 'clear') {
        window.open(documentUrl, '_blank')
      }
    },
    openDocumentMultiple (event, documentUrl) {
      if (event.target.textContent !== 'clear') {
        window.open(documentUrl, '_blank')
      }
    },
    async relatedModuleFieldChange (fieldHash, e, defaultOption = null, ownerHash = null) {

      let hasChilds = false
      let childFields = []

      if (this.childFields.hasOwnProperty(fieldHash)) {
        hasChilds = true
        childFields = this.childFields[fieldHash]
      }

      if (hasChilds && Array.isArray(childFields) && childFields.length > 0) {

        const targetChildren = ownerHash !== null ? [ownerHash] : childFields
        const parentSelections = Array.isArray(e) ? e : (e ? [e] : [])

        const clearChildCascade = (hash, visited = new Set()) => {
          if (visited.has(hash)) return
          visited.add(hash)

          const typeId = this.fieldType[hash]
          this.$set(this.optionFieldModel, hash, [])
          this.$set(this.dependentFieldDisableStatus, hash, true)
          this.$set(this.fieldModel, hash, typeId === this.$FIELD_TYPES.RELATED_TO_A_MODULE_MULTIPLE ? [] : null)

          if (this.childFields.hasOwnProperty(hash) && Array.isArray(this.childFields[hash])) {
            for (const child of this.childFields[hash]) {
              clearChildCascade(child, visited)
            }
          }
        }

        const valuesAreEqual = (left, right) => String(left) === String(right)

        for (const childHash of targetChildren) {
          const childTypeId = this.fieldType[childHash]

          // Clear helpers
          const clearChild = () => clearChildCascade(childHash)

          // No parent selection
          if (parentSelections.length === 0) {
            clearChild()
            continue
          }

          // Fetch options per parent selection (deduplicated)
          let aggregatedOptions = []
          for (const parentSelection of parentSelections) {
            const parentSelectionValue = parentSelection && typeof parentSelection === 'object' && parentSelection.value !== undefined
              ? parentSelection.value
              : parentSelection

            if (parentSelectionValue === null || parentSelectionValue === undefined || parentSelectionValue === '') {
              continue
            }
            const options = await this.fetchDependentChildOptions(childHash, parentSelectionValue)
            if (Array.isArray(options) && options.length > 0) {
              aggregatedOptions = aggregatedOptions.concat(options)
            }
          }

          // Deduplicate by option value
          const uniqueOptions = []
          const seen = new Set()
          aggregatedOptions.forEach(opt => {
            if (!seen.has(opt.value)) {
              seen.add(opt.value)
              uniqueOptions.push(opt)
            }
          })

          const previousValue = this.fieldModel[childHash]
          const previousSelections = Array.isArray(previousValue) ? previousValue : []
          const payloadValue = this.dataFieldPayload[childHash]
          const payloadLabel = this.dataFieldPayloadLabel[childHash]
          const payloadValues = Array.isArray(payloadValue)
            ? payloadValue
            : (typeof payloadValue === 'string' && payloadValue.includes(',')
                ? payloadValue.split(',').map(value => value.trim()).filter(Boolean)
                : (payloadValue !== null && payloadValue !== undefined && payloadValue !== '' ? [payloadValue] : []))
          const payloadLabels = Array.isArray(payloadLabel)
            ? payloadLabel
            : (typeof payloadLabel === 'string' && payloadLabel.includes(',')
                ? payloadLabel.split(',').map(value => value.trim())
                : (payloadLabel !== null && payloadLabel !== undefined && payloadLabel !== '' ? [payloadLabel] : []))

          if (uniqueOptions.length === 0 && payloadValues.length > 0) {
            payloadValues.forEach((value, index) => {
              uniqueOptions.push({
                value,
                label: payloadLabels[index] || payloadLabels[0] || String(value),
                selected: true
              })
            })
          }

          if (uniqueOptions.length === 0) {
            clearChild()
            continue
          }

          this.$set(this.optionFieldModel, childHash, uniqueOptions)
          this.$set(this.dependentFieldDisableStatus, childHash, false)

          // Apply value based on payload (existing field value)
          if (childTypeId === this.$FIELD_TYPES.RELATED_TO_A_MODULE_MULTIPLE) {
            const payloadSelections = payloadValues
              .map(value => uniqueOptions.find(opt => valuesAreEqual(opt.value, value)))
              .filter(Boolean)
              .map(opt => ({ value: opt.value, label: opt.label, selected: opt.selected }))
            const baseSelections = payloadSelections.length > 0
              ? payloadSelections
              : (Array.isArray(defaultOption) && defaultOption.length > 0 ? defaultOption : previousSelections)
            const validExisting = baseSelections
              .filter(sel => uniqueOptions.some(opt => valuesAreEqual(opt.value, sel.value)))
              .map(sel => {
                const opt = uniqueOptions.find(item => valuesAreEqual(item.value, sel.value))
                return opt ? { value: opt.value, label: opt.label, selected: opt.selected } : sel
              })

            const newValue = [...validExisting]
            this.$set(this.fieldModel, childHash, newValue)
          } else {
            const payloadCandidate = payloadValues.length > 0
              ? payloadValues[0]
              : null
            const payloadMatch = payloadCandidate
              ? uniqueOptions.find(opt => valuesAreEqual(opt.value, payloadCandidate))
              : null
            const candidate = (defaultOption && defaultOption.value !== undefined) ? defaultOption : previousValue
            const matched = payloadMatch || (candidate && candidate.value !== undefined
              ? uniqueOptions.find(opt => valuesAreEqual(opt.value, candidate.value))
              : null)
            const newValue = matched
              ? { value: matched.value, label: matched.label, selected: matched.selected }
              : null
            this.$set(this.fieldModel, childHash, newValue)
          }
        }
      }
    },
    async fetchDependentChildOptions (childHash, parentHash) {
      this.$vs.loading({ type: 'default' })
      try {
        const response = await performFetch(this.$store.state.auth.api_url, {
          command: 'get_related_module_options',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            module_token: this.$route.params.moduleHash,
            session_token: this.$store.state.auth.token,
            field_hash: childHash,
            parent_hash: parentHash
          }
        })

        this.$vs.loading.close()

        if (response.status === 200) {
          const responseData = await response.json()
          if (responseData && responseData.payload && Array.isArray(responseData.payload.options)) {
            return responseData.payload.options.map(opt => ({
              value: opt.value,
              label: (opt.label !== undefined && opt.label !== null
                ? opt.label
                : (opt.name !== undefined && opt.name !== null
                    ? opt.name
                    : (opt.title !== undefined && opt.title !== null ? opt.title : ''))),
              selected: opt.selected
            }))
          }
        }
      } catch (err) {
        console.error('Error fetching dependent options', err)
      }
      return []
    },
    closeImage (fieldHash) {
      this.viewMode[fieldHash] = !this.viewMode[fieldHash]
      this.fieldModel[fieldHash] = null
    },
    closeImageMultiple (fieldHash, fieldUrl) {
      // this.viewMode[fieldHash] = !this.viewMode[fieldHash]
      this.fieldModel[fieldHash] = this.fieldModel[fieldHash].filter(url => url !== fieldUrl)
    },
    clickImage (imagePayload) {
      const div = document.createElement('div')
      div.classList.add('view-upload')

      const img = document.createElement('img')

      img.setAttribute('src', imagePayload)

      div.appendChild(img)
      document.querySelector('body').prepend(div)
    },
    async successUpload (event, field) {
      // console.log('successUpload', event, field)
      const responseData = JSON.parse(event.srcElement.response)

      if (!responseData || !responseData.file_url) {
        this.$vs.notify({
          title: 'Atenção!',
          text: 'Falha ao anexar o arquivo. Tente novamente.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 5000
        })
        return
      }

      const documentRelatedFieldName = this.documentFieldModel.hasOwnProperty(field.hash) ? this.documentFieldModel[field.hash] : null

      if (documentRelatedFieldName !== null) {
        this.$set(this.fieldModel, documentRelatedFieldName, responseData.file_name)
      }

      this.$set(this.fieldModel, field.hash, responseData.file_url)
      this.$set(this.viewMode, field.hash, true)

      if (field.call_api) {
        this.$vs.loading({ type: 'default' })
        try {
          await this.callFieldApiExec(responseData.file_url, field.hash, field.minimal_timeout, true)

        } catch (e) {
          console.error('Error calling API exec on document:', e)
        }
        this.$vs.loading.close()
        // setTimeout(() => {
        // }, 1000);
        // this.$vs.loading.close();
      }
    },
    onDocumentUploadPending (pending) {
      this.documentUploadsPending += pending ? 1 : -1
      if (this.documentUploadsPending < 0) {
        this.documentUploadsPending = 0
      }
    },
    async successUploadMultiple (event, field) {

      const responseData = JSON.parse(event.srcElement.response)

      this.fieldModel[field.hash].push(responseData.file_url)
      this.newDocuments[field.hash].push(responseData.file_url)
    },
    deleteDocument (event, fieldHash) {
      const documentRelatedFieldName = this.documentFieldModel.hasOwnProperty(fieldHash) ? this.documentFieldModel[fieldHash] : null

      if (documentRelatedFieldName !== null) {
        this.fieldModel[documentRelatedFieldName] = null
      }
    },
    validateForm () {

      let hasFieldMandatory = false
      let hasIncorrectMinMaxValue = false
      let hasIncorretPattern = false

      for (const item of this.mandatoryFields) {

        if (this.blockIsVisible(item.block.related_picklist_hash, item.block.related_picklist_item_hash, item.block.show_on_add) && this.fieldIsVisible(item.related_picklist_field_hash, item.related_picklist_item_hash)) {
          if (this.fieldType[item.hash] === this.$FIELD_TYPES.MULTIPLE_DOCUMENTS && Array.isArray(this.fieldModel[item.hash]) && this.fieldModel[item.hash].length === 0) {
            this.$vs.notify({
              title: 'Atenção!',
              text: `O campo ${this.$displayLabel(item, 'title')} é obrigatório`,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
              time: 5000
            })
            hasFieldMandatory = true
          } else if (typeof this.fieldModel[item.hash] === 'object' && this.fieldModel[item.hash] !== null) {

            if (JSON.stringify(this.fieldModel[item.hash]) === '{}') {
              this.$vs.notify({
                title: 'Atenção!',
                text: `O campo ${this.$displayLabel(item, 'title')} é obrigatório`,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
                time: 5000
              })

              hasFieldMandatory = true
            } else if (this.fieldModel[item.hash].hasOwnProperty('value') && this.fieldModel[item.hash]['value'] === 0) {
              this.$vs.notify({
                title: 'Atenção!',
                text: `O campo ${this.$displayLabel(item, 'title')} é obrigatório`,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
                time: 5000
              })

              hasFieldMandatory = true
            }
          } else if (this.fieldType[item.hash] === this.$FIELD_TYPES.DECIMAL || this.fieldType[item.hash] === this.$FIELD_TYPES.CURRENCY || this.fieldType[item.hash] === this.$FIELD_TYPES.PERCENTAGE) {
            if (this.fieldModel[item.hash] === 0) {
              this.$vs.notify({
                title: 'Atenção!',
                text: `O campo ${this.$displayLabel(item, 'title')} é obrigatório`,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
                time: 5000
              })

              hasFieldMandatory = true
            }
          } else if (this.fieldModel[item.hash] === '' || this.fieldModel[item.hash] === null || this.fieldModel[item.hash] === undefined) {
            console.log('here')
            this.$vs.notify({
              title: 'Atenção!',
              text: `O campo ${this.$displayLabel(item, 'title')} é obrigatório`,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
              time: 5000
            })
            hasFieldMandatory = true
          }
        }
      }

      Object.keys(this.minValueMaxValueFields).forEach((item) => {

        if (this.fieldType[item] !== 12 && this.fieldType[item] !== 13) {
          if ((this.fieldModel[item] !== '' || this.fieldModel[item] !== null || this.fieldModel[item] !== undefined) && (this.minValueMaxValueFields[item]['minValue'] !== null && this.minValueMaxValueFields[item]['maxValue'])) {
            if ((parseInt(this.fieldModel[item]) < this.minValueMaxValueFields[item]['minValue']) || (parseInt(this.fieldModel[item]) > this.minValueMaxValueFields[item]['maxValue'])) {
              this.$vs.notify({
                title: 'Atenção!',
                text: `O valor do campo ${this.$displayLabel(this.fieldTitle[item], 'title')} deve estar entre ${this.minValueMaxValueFields[item]['minValue']} E ${this.minValueMaxValueFields[item]['maxValue']}`,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
                time: 5000
              })
              hasIncorrectMinMaxValue = true
            }
          }
        }
      })

      Object.entries(this.matchPatternFields).forEach(item => {

        const [key, value] = item

        const regex = new RegExp(value)

        if (Array.isArray(this.fieldModel[key])) {
          for (const __item of this.fieldModel[key]) {
            if (!regex.test(__item)) {
              this.$vs.notify({
                title: 'Atenção!',
                text: `O valor "${__item}" do campo ${this.$displayLabel(this.fieldTitle[key], 'title')} não corresponde ao padrão correto`,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
                time: 5000
              })
              hasIncorretPattern = true
              break
            }
          }
        }

      })

      return !hasFieldMandatory && !hasIncorrectMinMaxValue && !hasIncorretPattern
    },
    call_update_avatar (event) {
      const fieldHash = event.target.parentElement.parentElement.id.split('photo-preview-')[1] || event.target.parentElement.parentElement.id.split('photo-')[1]
      this.toggleShow(fieldHash)
      setApplicationLocalStorageItem('currentPhotoEditing', fieldHash)
    },
    toggleShow (fieldHash) {
      this.show[fieldHash] = !this.show[fieldHash]
    },
    dispatchUploadImage (elementId) {
      document.querySelector(`#${elementId}`).click()
    },
    uploadImageField (e) {
      e.preventDefault()
      const fieldHash = e.target.id.split('image-')[1]
      const preview = document.querySelector(`#image-id-${fieldHash}`)
      const file = document.querySelector(`#${e.target.id}`).files[0]
      const reader = new FileReader()

      // preview.parentElement.parentElement.parentElement.parentElement.querySelector('#upload-element').style.display = 'none'

      const me = this

      reader.onload = function (event) {
        const svg = event.target.result

        me.fieldModel[fieldHash] = {
          base64: svg,
          file_name: file.name
        }

        preview.src = svg

        // preview.parentElement.parentElement.parentElement.style.display = 'block'
      }

      if (file) {
        reader.readAsDataURL(file)
      }
    },
    getIconFromFieldType (typeId) {
      switch (typeId) {
      case 3:
        return 'phone-icon'
      case 4:
        return 'mail-icon'
      case 5:
        return 'instagram-icon'
      case 6:
        return 'facebook-icon'
      case 7:
        return 'linkedin-icon'
      case 8:
        return 'link-2-icon'
      case 9:
        return 'twitter-icon'
      case 10:
        return 'phone-icon'
      case 11:
        return 'youtube-icon'
      case 12:
      case 35:
        return 'calendar-icon'
      case 13:
        return 'clock-icon'
      case 14:
        return 'phone-icon'
      case 15:
        return 'slack-icon'
      case 16:
        return 'percent-icon'
      case 17:
        return 'clock-icon'
      case 18:
        return 'dollar-sign-icon'
      case 34:
        return 'trash-2-icon'
      }
    },
    fieldColumn (columnsOnForm, moduleColumns) {

      const width = (columnsOnForm / moduleColumns) * 100

      return `width: ${width}%!important;`

      // return `vx-col w-${columnsOnForm}/${moduleColumns}`
      // const fraction = columnsOnForm / moduleColumns;
      // const percentageClass = fraction === 1 ? 'w-full' : `w-${Math.round(fraction * 12)}/12`;
      // return `vx-col ${percentageClass}`;

      if (this.detail.max_columns === 1) {
        return 'vx-col w-full'
      } else if (this.detail.max_columns === 2) {
        if (columnsOnForm === 1) {
          return 'vx-col w-full md:w-1/2'
        } else {
          return 'vx-col w-full'
        }
      } else if (this.detail.max_columns === 3) {
        if (columnsOnForm === 1) {
          return 'vx-col w-full md:w-1/3'
        } else if (columnsOnForm === 2) {
          return 'vx-col w-full md:w-2/3'
        } else {
          return 'vx-col w-full'
        }
      } else if (columnsOnForm === 1) {
        return 'vx-col w-full md:w-1/4'
      } else if (columnsOnForm === 2) {
        return 'vx-col w-full md:w-1/2'
      } else if (columnsOnForm === 3) {
        return 'vx-col w-full md:w-3/4'
      } else {
        return 'vx-col w-full'
      }
    },
    handleFocusOut (field) {
      if (field.call_api && field.type_id !== 13) {
        this.onFieldChange(this.fieldModel[field.hash], field)
      }
    },
    setFieldsModels (fieldItem, rebuild = false) {
      this.$set(this.dataFieldPayload, fieldItem.hash, fieldItem.payload)
      this.$set(this.dataFieldPayloadLabel, fieldItem.hash, fieldItem.payload_label)
      if (fieldItem.secret) {
        this.$set(this.secretFields, fieldItem.hash, {
          visible: false
        })
      }

      if (fieldItem.mandatory) {
        if (!this.mandatoryFields.some(item => item.hash === fieldItem.hash)) {
          this.mandatoryFields.push(fieldItem)
        }
      }

      if (fieldItem.match_pattern) {
        this.$set(this.matchPatternFields, fieldItem.hash, fieldItem.match_pattern)
      }

      if (!rebuild) {
        if (fieldItem.type_id === this.$FIELD_TYPES.INTEGER) {

          try {
            parseInt(fieldItem.min_value)
            parseInt(fieldItem.max_value)

            if ((fieldItem.min_value !== null && fieldItem.max_value !== null) || (fieldItem.min_value !== undefined && fieldItem.max_value !== undefined)) {
              this.$set(this.minValueMaxValueFields, fieldItem.hash, {
                minValue: parseInt(fieldItem.min_value),
                maxValue: parseInt(fieldItem.max_value)
              })
            }
          } catch (e) {
            //
          }
        }


        if (fieldItem.type_id === this.$FIELD_TYPES.CURRENCY) {
          this.$set(this.currencyFields, fieldItem.hash, {
            decimal: ',',
            thousands: '.',
            prefix: '',
            suffix: '',
            precision: fieldItem.decimals || 2,
            masked: false
          })

          if (fieldItem.payload === '' || fieldItem.payload === null) {
            fieldItem.payload = 0
          } else {
            fieldItem.payload = parseFloat(fieldItem.payload)
          }

          this.$set(this.fieldModel, fieldItem.hash, fieldItem.payload)
        } else if (fieldItem.type_id === this.$FIELD_TYPES.DECIMAL || fieldItem.type_id === this.$FIELD_TYPES.PERCENTAGE) {

          this.$set(this.decimalFields, fieldItem.hash, {
            decimal: ',',
            thousands: '.',
            prefix: '',
            suffix: '',
            precision: fieldItem.decimals,
            masked: false
          })

          if (fieldItem.payload === '' || fieldItem.payload === null) {
            fieldItem.payload = 0
          } else {
            fieldItem.payload = parseFloat(fieldItem.payload)
          }

          this.$set(this.fieldModel, fieldItem.hash, fieldItem.payload)

        } else if (fieldItem.type_id === this.$FIELD_TYPES.IMAGE) {
          this.$set(this.hoverImageList, fieldItem.hash, true)
          this.$set(this.viewMode, fieldItem.hash, true)
          this.$set(this.fieldModel, fieldItem.hash, fieldItem.payload)
        } else if (fieldItem.type_id === this.$FIELD_TYPES.PHOTO) {
          this.$set(this.show, fieldItem.hash, false)
          this.$set(this.viewMode, fieldItem.hash, true)
          this.$set(this.fieldModel, fieldItem.hash, fieldItem.payload)
        } else if (fieldItem.type_id === this.$FIELD_TYPES.PICKLIST && fieldItem.name === 'assigned_to_id') {
          this.$set(this.fieldModel, fieldItem.hash, {})

          const optionsList = []

          fieldItem.options.forEach((optionFieldItem) => {

            optionsList.push({ value: optionFieldItem.value, label: optionFieldItem.label, label_en: optionFieldItem.label_en, group: optionFieldItem.group, groupLevel: optionFieldItem.groupLevel, assignTypeId: optionFieldItem.assignTypeId, selected: optionFieldItem.selected })

            if (optionFieldItem.selected) {
              this.$set(this.fieldModel, fieldItem.hash, { value: optionFieldItem.value, label: optionFieldItem.label, label_en: optionFieldItem.label_en, group: optionFieldItem.group, groupLevel: optionFieldItem.groupLevel, assignTypeId: optionFieldItem.assignTypeId, selected: optionFieldItem.selected })
              // this.fieldModel[fieldItem.hash] = { value: optionFieldItem.value, label: optionFieldItem.label, group: optionFieldItem.group, groupLevel: optionFieldItem.groupLevel, assignTypeId: optionFieldItem.assignTypeId, selected: optionFieldItem.selected }
            }
          })

          this.$set(this.optionFieldModel, fieldItem.hash, optionsList)
        } else if ((fieldItem.type_id === this.$FIELD_TYPES.PICKLIST || fieldItem.type_id === this.$FIELD_TYPES.RELATED_TO_A_USER) && fieldItem.name !== 'assigned_to_id') {

          this.$set(this.keyPicklistItems, fieldItem.hash, {})
          this.$set(this.fieldModel, fieldItem.hash, {})
          const optionsList = []
          fieldItem.options.forEach((optionFieldItem) => {

            optionsList.push({ value: optionFieldItem.value, label: optionFieldItem.label, label_en: optionFieldItem.label_en })

            if (optionFieldItem.selected || (fieldItem.payload === null && fieldItem.default_value === optionFieldItem.label)) {
              setTimeout(() => {
                this.fieldModel[fieldItem.hash] = { value: optionFieldItem.value, label: optionFieldItem.label, label_en: optionFieldItem.label_en }
                this.onPicklistFieldChange({ value: optionFieldItem.value, label: optionFieldItem.label, label_en: optionFieldItem.label_en }, fieldItem.hash)
              }, 300)
            }

            this.$set(this.keyPicklistItems[fieldItem.hash], optionFieldItem.value, !!optionFieldItem.selected)
          })

          this.$set(this.optionFieldModel, fieldItem.hash, optionsList)

        } else if (fieldItem.type_id === this.$FIELD_TYPES.MULTIPLE_LIST && fieldItem.name !== 'assigned_to_id_multiple') {
          // } else if(fieldItem.type_id === 32 || fieldItem.type_id === 33) {

          this.$set(this.keyPicklistItems, fieldItem.hash, {})
          this.$set(this.fieldModel, fieldItem.hash, [])
          const optionsList = []
          fieldItem.options.forEach((optionFieldItem) => {

            optionsList.push({ value: optionFieldItem.value, label: optionFieldItem.label, label_en: optionFieldItem.label_en })

            this.$set(this.keyPicklistItems[fieldItem.hash], optionFieldItem.value, !!optionFieldItem.selected)
          })

          if (fieldItem.payload === null) {
            fieldItem.payload = []
          }

          fieldItem.payload.forEach(payload => {
            const option = fieldItem.options.find(x => x.value === payload)

            if (option !== undefined) {
              this.fieldModel[fieldItem.hash].push({ value: option.value, label: option.label, label_en: option.label_en })
            }
          })

          this.$set(this.optionFieldModel, fieldItem.hash, optionsList)

        } else if (fieldItem.type_id === this.$FIELD_TYPES.MULTIPLE_LIST && fieldItem.name === 'assigned_to_id_multiple') {

          this.$set(this.fieldModel, fieldItem.hash, [])

          const optionsList = []

          fieldItem.options.forEach((optionFieldItem) => {

            optionsList.push({ value: optionFieldItem.value, label: optionFieldItem.label, label_en: optionFieldItem.label_en, group: optionFieldItem.group, groupLevel: optionFieldItem.groupLevel, assignTypeId: optionFieldItem.assignTypeId, selected: optionFieldItem.selected })

            if (optionFieldItem.selected) {
              // this.$set(this.fieldModel, fieldItem.hash, { value: optionFieldItem.value, label: optionFieldItem.label, group: optionFieldItem.group, groupLevel: optionFieldItem.groupLevel, assignTypeId: optionFieldItem.assignTypeId, selected: optionFieldItem.selected })
              this.fieldModel[fieldItem.hash].push({ value: optionFieldItem.value, label: optionFieldItem.label, label_en: optionFieldItem.label_en, group: optionFieldItem.group, groupLevel: optionFieldItem.groupLevel, assignTypeId: optionFieldItem.assignTypeId, selected: optionFieldItem.selected })
            }
          })

          this.$set(this.optionFieldModel, fieldItem.hash, optionsList)

        } else if (fieldItem.type_id === this.$FIELD_TYPES.RELATED_TO_A_MODULE || fieldItem.type_id === this.$FIELD_TYPES.RELATED_TO_KANBAN) {

          const optionsList = []

          if (Array.isArray(fieldItem.options)) {

            let fieldModelChanged = false

            // fieldItem.options.forEach((optionFieldItem) => {
            for (const optionFieldItem of fieldItem.options) {

              optionsList.push({ value: optionFieldItem.value, label: optionFieldItem.label, label_en: optionFieldItem.label_en })

              if (optionFieldItem.selected) {
                // this.fieldModel[fieldItem.hash] = { value: optionFieldItem.value, label: optionFieldItem.label }
                // setTimeout(() => {
                this.$set(this.fieldModel, fieldItem.hash, { value: optionFieldItem.value, label: optionFieldItem.label })
                fieldModelChanged = true
                // }, 300)
              }
            }

            this.$set(this.optionFieldModel, fieldItem.hash, optionsList)
            // this.$set(this.optionFieldModel, fieldItem.hash, optionsList)

            this.$set(this.dependentFieldDisableStatus, fieldItem.hash, false)

            if (!fieldModelChanged) {
              this.$set(this.fieldModel, fieldItem.hash, null)
            }

          } else {

            this.$set(this.dependentFieldOptions, fieldItem.hash, fieldItem.options)
            this.$set(this.optionFieldModel, fieldItem.hash, [])
            this.$set(this.dependentFieldDisableStatus, fieldItem.hash, true)

            let defaultOptions = null

            if (fieldItem.type_id == 33) {
              defaultOptions = []
            }

            for (const item of Object.keys(fieldItem.options)) {
              for (const itemOption of fieldItem.options[item]) {
                // fieldItem.options[item].forEach((itemOption) => {
                if (itemOption.selected) {

                  if (fieldItem.type_id === 33) {
                    defaultOptions.push({ value: itemOption.value, label: itemOption.label })
                  } else {
                    defaultOptions = { value: itemOption.value, label: itemOption.label }
                  }
                }
                // })
              }

            }

            // Object.keys(fieldItem.options).forEach(item => {
            // })

            // setTimeout(() => {

            if (!this.fieldModel[fieldItem['related_parent_hash']] || JSON.stringify(this.fieldModel[fieldItem['related_parent_hash']]) === '{}') {
              this.$set(this.fieldModel, fieldItem.hash, null)
              //
            } else {
              this.$set(this.fieldModel, fieldItem.hash, defaultOptions)
              this.relatedModuleFieldChange(fieldItem['related_parent_hash'], this.fieldModel[fieldItem['related_parent_hash']], defaultOptions, fieldItem.hash)
            }

            // }, 300)

          }

          if (Array.isArray(fieldItem.field_children)) {
            this.$set(this.childFields, fieldItem.hash, fieldItem.field_children)
          }

        } else if (fieldItem.type_id === this.$FIELD_TYPES.MAP) {
          if (typeof fieldItem.payload === 'string' && fieldItem.payload.split(',').length > 0) {
            fieldItem.payload = { lat: parseFloat(fieldItem.payload.split(',')[0]), lng: parseFloat(fieldItem.payload.split(',')[1]) }
          } else {
            fieldItem.payload = { lat: -23.501103, lng: -46.8504457 }
          }
        } else if (fieldItem.type_id === this.$FIELD_TYPES.DOCUMENT) {
          // this.$set(this.show, fieldItem.hash, false)
          if (fieldItem.payload !== null) {
            this.$set(this.viewMode, fieldItem.hash, true)
            this.$set(this.fieldModel, fieldItem.hash, fieldItem.payload)
          } else {
            this.$set(this.viewMode, fieldItem.hash, false)
            this.$set(this.fieldModel, fieldItem.hash, null)
          }
          // this.$set(this.viewMode, fieldItem.hash, true)

          this.documentFieldModel[fieldItem.hash] = fieldItem.document_name_field_hash
        } else if (fieldItem.type_id === this.$FIELD_TYPES.MULTIPLE_DOCUMENTS) {
          if (fieldItem.payload !== null) {
            this.$set(this.fieldModel, fieldItem.hash, fieldItem.payload)
          } else {
            this.$set(this.viewMode, fieldItem.hash, false)
            this.$set(this.fieldModel, fieldItem.hash, [])
          }
          this.$set(this.newDocuments, fieldItem.hash, [])

        } else if (fieldItem.type_id === this.$FIELD_TYPES.BADGE) {

          this.$set(this.fieldModel, fieldItem.hash, {})
          const optionsList = []
          fieldItem.options.forEach((optionFieldItem) => {

            optionsList.push({ value: optionFieldItem.value, label: optionFieldItem.label, label_en: optionFieldItem.label_en, color: optionFieldItem.color, selected: optionFieldItem.selected })

          })

          this.fieldModel[fieldItem.hash] = {}

          const defaultObject = optionsList.find(x => x.label === fieldItem.default_value)

          const selectedObject = optionsList.find(x => x.selected === true)

          if (fieldItem.payload === null) {
            this.fieldModel[fieldItem.hash] = defaultObject
          } else {
            this.fieldModel[fieldItem.hash] = selectedObject
          }

          this.$set(this.optionFieldModel, fieldItem.hash, optionsList)
        } else if (fieldItem.type_id === this.$FIELD_TYPES.TABLE) {
          this.$set(this.fieldModel, fieldItem.hash, [])
          this.$set(this.selectedItemsRows, fieldItem.hash, [])
          this.$set(this.itemsDataModel, fieldItem.hash, {})
          this.$set(this.tableItemsToDelete, fieldItem.hash, [])
          this.$set(this.listItemsIndex, fieldItem.hash, [])

          const moduleItemsTitles = []

          //build structure

          // const listIndex = 0

          if (Array.isArray(fieldItem.table_fields) && fieldItem.table_fields.length > 0) {
            for (const field of fieldItem.table_fields) {

              moduleItemsTitles.push({ name: field.name, title: field.title, title_en: field.title_en })

              if (field.name === 'hash') {
                this.$set(this.tableHashFields, fieldItem.hash, field.hash)
              } else {
                this.listItemsIndex[fieldItem.hash].push(field.hash)
              }

              this.$set(this.itemsModuleFieldsProperties, field.hash, field)

              this.setFieldsModels(field)
              this.tablesFieldsList.push(field.hash)
            }

            this.$set(this.moduleItemsFields, fieldItem.hash, fieldItem.table_fields)
          }

          this.$set(this.moduleItemsTitlesModel, fieldItem.hash, moduleItemsTitles)

          if (Array.isArray(fieldItem.payload) && fieldItem.payload.length > 0) {

            for (const fieldRow of fieldItem.payload) {

              const formDataArr = []
              const formDataRaw = {}

              for (const $fieldItem of fieldRow) {

                if (Array.isArray($fieldItem.options) && $fieldItem.options.length > 0) {

                  let value = null

                  value = $fieldItem.options.find(x => x.value === $fieldItem.payload)

                  formDataArr.push([$fieldItem.hash, value])
                } else {
                  formDataArr.push([$fieldItem.hash, $fieldItem.payload])
                }

                this.setFieldsModels($fieldItem)

                formDataRaw[$fieldItem.hash] = this.fieldModel[$fieldItem.hash]
              }

              this.updateItemsList(formDataArr, fieldItem.hash, formDataRaw)

              // const fieldHashIndex = fieldRow.findIndex(x => x.name === 'hash')

              // if(fieldHashIndex > -1) {
              //   fieldRow.splice(fieldHashIndex, 1)
              // }

              // this.$set(this.moduleItemsFields, fieldItem.hash, fieldRow)
            }
          }

        } else if (fieldItem.type_id === this.$FIELD_TYPES.MULTIPLE_LIST || fieldItem.type_id === this.$FIELD_TYPES.RELATED_TO_A_MODULE_MULTIPLE) {
          this.$set(this.keyPicklistItems, fieldItem.hash, {})
          this.$set(this.fieldModel, fieldItem.hash, [])
          const optionsList = []

          this.$set(this.optionFieldModel, fieldItem.hash, [])

          if (!Array.isArray(fieldItem.options)) {
            this.$set(this.dependentFieldOptions, fieldItem.hash, fieldItem.options)
            this.$set(this.dependentFieldDisableStatus, fieldItem.hash, true)
          }

          let defaultOptions = null

          if (fieldItem.type_id === this.$FIELD_TYPES.RELATED_TO_A_MODULE_MULTIPLE) {
            defaultOptions = []
          }

          if (!Array.isArray(fieldItem.options)) {

            Object.keys(fieldItem.options).forEach(item => {

              fieldItem.options[item].forEach((itemOption) => {
                if (itemOption.selected) {

                  if (fieldItem.type_id === this.$FIELD_TYPES.RELATED_TO_A_MODULE_MULTIPLE) {
                    defaultOptions.push({ value: itemOption.value, label: itemOption.label })
                  } else {
                    defaultOptions = { value: itemOption.value, label: itemOption.label }
                  }
                }

                optionsList.push({ value: itemOption.value, label: itemOption.label })

              })
            })
          } else {
            fieldItem.options.forEach((itemOption) => {
              if (itemOption.selected) {
                if (fieldItem.type_id === this.$FIELD_TYPES.RELATED_TO_A_MODULE_MULTIPLE) {
                  defaultOptions.push({ value: itemOption.value, label: itemOption.label })
                } else {
                  defaultOptions = { value: itemOption.value, label: itemOption.label }
                }
              }

              optionsList.push({ value: itemOption.value, label: itemOption.label })

            })
          }

          // fieldItem.options.forEach((optionFieldItem) => {

          //   optionsList.push({ value: optionFieldItem.value, label: optionFieldItem.label })

          //   this.$set(this.keyPicklistItems[fieldItem.hash], optionFieldItem.value, optionFieldItem.selected ? true : false)
          // })

          // fieldItem.payload.forEach(payload => {
          //   const option = fieldItem.options.find(x => x.value === payload)

          //   if(option !== undefined) {
          //     this.fieldModel[fieldItem.hash].push({ value: option.value, label: option.label })
          //   }
          // })

          if (Array.isArray(fieldItem.field_children) && fieldItem.field_children.length > 0) {
            this.$set(this.childFields, fieldItem.hash, fieldItem.field_children)
          }

          this.$set(this.optionFieldModel, fieldItem.hash, optionsList)
          this.$set(this.fieldModel, fieldItem.hash, defaultOptions)

          if (JSON.stringify(this.fieldModel[fieldItem['related_parent_hash']]) === '{}') {
            //
          } else {
            // this.$set(this.dependentFieldOptions, fieldItem.hash, optionsList)
            this.relatedModuleFieldChange(fieldItem['related_parent_hash'], this.fieldModel[fieldItem['related_parent_hash']], defaultOptions, fieldItem.hash)
          }
        } else if (fieldItem.type_id === this.$FIELD_TYPES.MULTIPLE_DATE) {
          if (Array.isArray(fieldItem.payload)) {
            this.$set(this.fieldModel, fieldItem.hash, fieldItem.payload.join(', '))
          }
        } else {
          this.$set(this.fieldModel, fieldItem.hash, fieldItem.payload)
        }

        // if (fieldItem.type_id !== this.$FIELD_TYPES.PICKLIST && fieldItem.type_id !== this.$FIELD_TYPES.RELATED_TO_A_MODULE && fieldItem.type_id !== this.$FIELD_TYPES.BADGE && fieldItem.type_id !== this.$FIELD_TYPES.RELATED_TO_KANBAN && fieldItem.type_id !== this.$FIELD_TYPES.TABLE && fieldItem.type_id !== this.$FIELD_TYPES.MULTIPLE_LIST  && fieldItem.type_id !== this.$FIELD_TYPES.RELATED_TO_A_MODULE_MULTIPLE) {
        //   this.$set(this.fieldModel, fieldItem.hash, fieldItem.payload)
        // }

        // if (![this.$FIELD_TYPES.PICKLIST, this.$FIELD_TYPES.RELATED_TO_A_MODULE, this.$FIELD_TYPES.BADGE, this.$FIELD_TYPES.RELATED_TO_KANBAN, this.$FIELD_TYPES.TABLE, this.$FIELD_TYPES.MULTIPLE_LIST, this.$FIELD_TYPES.RELATED_TO_A_MODULE_MULTIPLE].includes(fieldItem.type_id)) {
        //   this.$set(this.fieldModel, fieldItem.hash, fieldItem.payload)
        // }

        //END FORMAT FIELD PAYLOAD BY TYPE ID

        this.$set(this.fieldTitle, fieldItem.hash, { title: fieldItem.title, title_en: fieldItem.title_en })
        this.$set(this.fieldName, fieldItem.hash, fieldItem.name)
        this.$set(this.fieldType, fieldItem.hash, fieldItem.type_id)
        this.$set(this.fieldsKeys, fieldItem.hash, (Math.random() + 1).toString(36).substring(2))
      }
    },
    setBlocks (rebuild = false) {

      this.mandatoryFields = []

      const visibleBlocks = this.blocksOriginal
        .filter((el) => el.visible)
        .sort((a, b) => {
          if (a.index < b.index) return -1
          if (a.index > b.index) return 1
          return 0
        }) // get only visible blocks, ordered by layout index

      this.embbededFields = []

      for (const item of this.blocksOriginal) {
        if (item.content_type === 'embbeded' && !this.embbededFields.includes(item.hash)) {
          this.embbededFields.push(item.hash)
        }
      }

      const blocksData = []

      for (const item of visibleBlocks) {

        item.fields.sort((a, b) => {
          if (a.index < b.index) return -1
          if (a.index < b.index) return 1
          return 0
        })

        const fieldItems = []

        for (const fieldItem of item.fields) {
          this.setFieldsModels(fieldItem, rebuild)
          //this.$nextTick();
        }

        item.fields.sort((a, b) => {
          if (a.index < b.index) return -1
          if (a.index < b.index) return 1
          return 0
        })

        for (const fieldItem of item.fields) {
          fieldItem.block = item
          if (this.fieldIsVisible(fieldItem.related_picklist_field_hash, fieldItem.related_picklist_item_hash)) {
            fieldItems.push(fieldItem)
          }

        }

        // item.fields.forEach(fieldItem => {
        // })

        const data = []

        const i = 0

        let temparray = []

        const maxColumns = this.detail.max_columns

        let currentColumns = 0

        let start = 0

        let k = 0

        let last = 0

        while (k < fieldItems.length) {

          if (fieldItems[k].entire_line) {
            currentColumns += maxColumns
          } else {
            currentColumns += fieldItems[k].columns_on_form
          }

          if (currentColumns > maxColumns) {

            temparray = fieldItems.slice(start, last + 1)

            data.push(temparray)

            start = k

            k--

            currentColumns = 0

          } else if (currentColumns === maxColumns) {

            temparray = fieldItems.slice(start, k + 1)

            data.push(temparray)

            start = k + 1

            currentColumns = 0

          } else if (k === (fieldItems.length - 1)) {

            temparray = fieldItems.slice(start, fieldItems.length)

            data.push(temparray)

            start = k + 1

            currentColumns = 0

          }

          last = k

          k++
        }

        if (this.blockIsVisible(item.related_picklist_hash, item.related_picklist_item_hash, item.show_on_add)) {
          const obj = {
            hash: item.hash,
            collapsed: item.collapsed,
            fieldList: data.sort((a, b) => a.index - b.index),
            title: item.title,
            title_en: item.title_en,
            index: item.index,
            content_type: item.content_type,
            content_url: item.content_url,
            show_on_add: item.show_on_add,
            require_iframe_submit_ready: item.require_iframe_submit_ready === true,
            visible: item.visible,
            related_picklist_hash: item.related_picklist_hash,
            related_picklist_item_hash: item.related_picklist_item_hash
          }

          blocksData.push(obj)

          // this.$set(this.blocks, key, obj)
          this.$set(this.blocks, item.hash, obj)
        }
      }
      // )

      blocksData.sort((a, b) => {
        if (a.index < b.index) return -1
        if (a.index > b.index) return 1
        return 0
      })

      this.blocks = blocksData

      const gatedHashes = new Set()
      for (const b of this.blocks) {
        if (b.content_type === 'embbeded' && b.require_iframe_submit_ready) {
          gatedHashes.add(b.hash)
        }
      }
      Object.keys(this.iframeSubmitReadyByHash).forEach((h) => {
        if (!gatedHashes.has(h)) {
          this.$delete(this.iframeSubmitReadyByHash, h)
        }
      })
      gatedHashes.forEach((h) => {
        this.$set(this.iframeSubmitReadyByHash, h, false)
      })

      if (this.actionType !== 'add' && !rebuild && !this.dependentFieldsInitialized) {
        this.initializeDependentFields()
        this.dependentFieldsInitialized = true
      }

    },
    initializeDependentFields () {
      const hasSelection = (value) => {
        if (Array.isArray(value)) {
          return value.length > 0
        }
        if (value && typeof value === 'object') {
          return Object.keys(value).length > 0 && value.value !== undefined
        }
        return value !== null && value !== undefined && value !== ''
      }

      Object.keys(this.childFields).forEach(parentHash => {
        let parentValue = this.fieldModel[parentHash]
        if (!hasSelection(parentValue)) {
          const payloadValue = this.dataFieldPayload[parentHash]
          const payloadLabel = this.dataFieldPayloadLabel[parentHash]
          const payloadValues = Array.isArray(payloadValue)
            ? payloadValue
            : (payloadValue !== null && payloadValue !== undefined && payloadValue !== '' ? [payloadValue] : [])
          const payloadLabels = Array.isArray(payloadLabel)
            ? payloadLabel
            : (payloadLabel !== null && payloadLabel !== undefined && payloadLabel !== '' ? [payloadLabel] : [])

          if (payloadValues.length > 0) {
            if (Array.isArray(this.fieldModel[parentHash])) {
              parentValue = payloadValues.map((value, index) => ({
                value,
                label: payloadLabels[index] || payloadLabels[0] || String(value)
              }))
            } else {
              parentValue = {
                value: payloadValues[0],
                label: payloadLabels[0] || String(payloadValues[0])
              }
            }
          }
        }

        if (!hasSelection(parentValue)) {
          return
        }

        const childHashes = this.childFields[parentHash]
        if (!Array.isArray(childHashes)) {
          return
        }

        childHashes.forEach(childHash => {
          const childValue = this.fieldModel[childHash]
          const defaultOption = Array.isArray(childValue) ? null : (childValue || null)
          this.relatedModuleFieldChange(parentHash, parentValue, defaultOption, childHash)
        })
      })
    },
    async changePhoto (imageDataUrl) {
      const fieldHash = getApplicationLocalStorageItem('currentPhotoEditing')
      this.fieldModel[fieldHash] = imageDataUrl
      document.querySelector(`#photo-${fieldHash}`).style.display = 'none'
      document.querySelector(`#photo-preview-${fieldHash}`).children[0].children[0].src = imageDataUrl
      removeApplicationLocalStorageItem('currentPhotoEditing')
      setTimeout(() => {
        document.querySelector(`#div-photo-${fieldHash}`).style.marginTop = '0px'
        document.querySelector(`#div-photo-${fieldHash}`).style.marginLeft = '0px'
        document.querySelectorAll(`#photo-preview-${fieldHash}`)[0].style.display = 'block'
      }, 300)
    },
    camelToSnakeCase (str) {
      const camelToSnakeCase = str => str.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`)
      return camelToSnakeCase(str).substring(1)
    },
    setSelectedField (val) {
      //
    },
    updateSingleField (field) {
      this.enableEdit[field.name] = !this.enableEdit[field.name]
      this.$vs.notify({
        title: 'Operação Realizada!',
        text: 'Atualização do campo realizada!',
        iconPack: 'feather',
        icon: 'icon-check-circle',
        color: 'success'
      })
    },
    cancelUpdateSingleField (field) {
      this.enableEdit[field.name] = !this.enableEdit[field.name]
      this.$vs.notify({
        title: 'Operação Cancelada!',
        text: 'Atualização do campo cancelada!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
    },
    checkIfStringIsDateTime (string) {

      try {
        if ((string.split('/').length - 1) == 2 && (string.split(':').length - 1) == 2 && (string.split(' ').length - 1) == 1) {
          return true
        } else {
          return false
        }
      } catch (e) {
        return false
      }
    },
    checkIfStringIsDate (string) {
      try {
        if ((string.split('/').length - 1) == 2 && (string.length === 10)) {
          return true
        } else {
          return false
        }
      } catch (e) {
        return false
      }
    },
    checkIfStringIsDateTimeDashFormat (string) {

      try {
        if ((string.split('-').length - 1) == 2 && (string.split(':').length - 1) == 2 && (string.split(' ').length - 1) == 1) {
          return true
        } else {
          return false
        }
      } catch (e) {
        return false
      }
    },
    checkIfStringIsDateDashFormat (string) {
      try {
        if ((string.split('-').length - 1) == 2 && (string.length === 10)) {
          return true
        } else {
          return false
        }
      } catch (e) {
        return false
      }
    },
    async buildRowData () {
      const newFieldData = {}

      return new Promise((resolve, reject) => {
        for (const item of Object.keys(this.fieldModel)) {
          console.log(this.fieldModel[item], typeof this.fieldModel[item])

          if (this.fieldType[item] !== this.$FIELD_TYPES.MAP && !this.tablesFieldsList.includes(item)) {
            if (this.fieldModel[item] === '') {
              newFieldData[item] = null
            } else if (typeof this.fieldModel[item] === 'object' && this.fieldModel[item] !== null && this.fieldName[item] === 'assigned_to_id') {
              newFieldData[item] = this.fieldModel[item]['value']
            } else if (typeof this.fieldModel[item] === 'object' && this.fieldModel[item] !== null && this.fieldType[item] === 24) {
              if (this.fieldModel[item]['value'] === 0) {
                newFieldData[item] = null
              } else {
                newFieldData[item] = this.fieldModel[item]['value']
              }
            } else if (typeof this.fieldModel[item] === 'object' && this.fieldModel[item] !== null && this.fieldType[item] === 29) {
              newFieldData[item] = this.fieldModel[item]['value']
            } else if (typeof this.fieldModel[item] === 'object' && this.fieldModel[item] !== null && (this.fieldType[item] === 25 || this.fieldType[item] === 30)) {
              if (this.fieldModel[item]['value'] === 0) {
                newFieldData[item] = null
              } else {
                newFieldData[item] = this.fieldModel[item]['value']
              }
            } else if (typeof this.fieldModel[item] === 'string' && this.fieldModel[item] !== null && this.fieldType[item] === 17) {
              if (this.fieldModel[item].length === 6) {
                newFieldData[item] = `${this.fieldModel[item].slice(0, 2)  }:${  this.fieldModel[item].slice(2, 4)  }:${  this.fieldModel[item].slice(4, 6)}`
              } else if (this.fieldModel[item].length === 4) {
                newFieldData[item] = `${this.fieldModel[item].slice(0, 2)  }:${  this.fieldModel[item].slice(2, 4)}`
              }
            } else if (this.fieldType[item] === 2) {
              try {
                newFieldData[item] = parseInt(this.fieldModel[item])
              } catch (e) {

              }
            } else if (this.fieldType[item] === 32 || this.fieldType[item] === 33) {

              const valuesData = []

              if (Array.isArray(this.fieldModel[item])) {
                for (const arrayItem of this.fieldModel[item]) {
                  valuesData.push(arrayItem['value'])
                }
              }

              newFieldData[item] = valuesData

            } else if (this.fieldType[item] === 16 || this.fieldType[item] === 18 || this.fieldType[item] === 20 || this.fieldType[item] === 20) {
              try {
                newFieldData[item] = parseFloat(this.fieldModel[item])
              } catch (e) {

              }
            } else if (this.fieldType[item] === this.$FIELD_TYPES.MULTIPLE_DATE) {
              if (typeof this.fieldModel[item] === 'string') {
                newFieldData[item] = this.fieldModel[item].split(', ')
              } else {
                newFieldData[item] = null
              }
            } else {
              newFieldData[item] = this.fieldModel[item]
            }
          }
        }

        resolve(newFieldData)
      })
    },
    async saveChangesAdd () {
      const moduleHash = this.$route.params.moduleHash
      let newFieldData = null

      if (this.validateForm()) {
        this.$vs.loading({ type: 'default' })

        if (newFieldData === null) {
          newFieldData = await this.buildRowData()
        }

        const requestBody = {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: moduleHash,
          data: newFieldData
        }

        await performFetch(this.$store.state.auth.api_url, {
          command: 'add_module_row',
          parameters: requestBody
        })
          .then(async (response) => {
            if (response.status === 200) {
              response.json().then(async (response) => {

                this.$vs.loading.close()

                this.$vs.notify({
                  title: 'Operação Realizada!',
                  text: response.message,
                  iconPack: 'feather',
                  icon: 'icon-check-circle',
                  color: 'success',
                  time: 5000
                })

                try {
                  this.communicateEmbbededFields({
                    event: 'onSave',
                    rowState: this.fieldModel,
                    rowHash: response.new_row_hash
                  })
                } catch (e) {
                  console.error('error communicating embbeded fields - master', e)
                }

                setTimeout(() => {
                  if (this.detailProp.on_add_row_navigation_type === 'edit') {
                    this.$router.push(`/modules/edit/${this.$route.params.moduleHash}/${response.new_row_hash}`)
                  } else if (this.detailProp.on_add_row_navigation_type === 'view') {
                    this.$router.push(`/modules/view/${this.$route.params.moduleHash}/${response.new_row_hash}`)
                  } else if (this.detailProp.on_add_row_navigation_type === 'list') {
                    this.$router.push(`/modules/${this.$route.params.moduleHash}`)
                  } else {
                    this.$router.go(-1)
                  }
                }, 300)


                // for(let key in this.fieldModel) {
                //   this.fieldModel[key] = null
                // }

                // if(this.$route.params.relatedModuleHash && this.$route.params.relatedModuleRowHash) {
                //   this.$router.go(-1)
                // } else {
                //   this.$router.push(`/modules/${this.$route.params.moduleHash}`)
                // }
              })
            } else if (response.status == 401) {
              setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
              this.$store.dispatch('auth/signOut')
            } else if (response.status === 400) {
              this.$vs.loading.close()
              response.json().then((responseData) => {
                this.$vs.notify({
                  title: 'Operação não realizada!',
                  text: responseData.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'warning',
                  time: 5000
                })
              })
            } else {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Operação não realizada!',
                text: 'Ocorreu um erro ao salvar o registro',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger',
                time: 5000
              })
            }
          })
          .catch((e) => {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Operação não realizada!',
              text: e.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              time: 5000
            })
            throw new Error(e.message)
          })
      }
    },
    async saveChangesEdit () {
      if (this.documentUploadsPending > 0) {
        this.$vs.notify({
          title: 'Atenção!',
          text: 'Aguarde o envio dos anexos terminar antes de submeter.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 5000
        })
        return
      }
      if (this.validateForm()) {
        this.$vs.loading({ type: 'default' })

        const newFieldData = await this.buildRowData()

        const requestBody = {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: this.$route.params.moduleHash,
          data: newFieldData
        }

        if (this.$route.params.rowHash) {
          requestBody['row_hash'] = this.$route.params.rowHash
        }


        await performFetch(this.$store.state.auth.api_url, {
          command: 'update_module_row',
          parameters: requestBody
        })
          .then(async (response) => {
            if (response.status === 200) {
              response.json().then(async (response) => {

                this.$vs.loading.close()

                this.$vs.notify({
                  title: 'Operação Realizada!',
                  text: response.message,
                  iconPack: 'feather',
                  icon: 'icon-check-circle',
                  color: 'success'
                })

                // if (this.$route.params.rowHash) {
                //   this.$router.push(`/modules/${this.$route.params.moduleHash}`)
                // } else {
                //   this.$router.push(`/modules/view/${this.$route.params.moduleHash}`)
                // }
              })
            } else if (response.status == 401) {
              setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
              this.$store.dispatch('auth/signOut')
            } else if (response.status === 400) {
              this.$vs.loading.close()
              response.json().then((responseData) => {
                this.$vs.notify({
                  title: 'Operação não realizada!',
                  text: responseData.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'warning',
                  time: 5000
                })
              })
            } else if (response.status == 403) {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Atenção',
                text: 'Você não tem permissão para editar registros neste módulo',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
                time: 5000
              })
            } else {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Operação não realizada!',
                text: 'Ocorreu um erro ao atualizar o registro',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            }
          })
          .catch((e) => {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Operação não realizada!',
              text: e.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
            throw new Error(e.message)
          })
      }
    },
    async saveChanges () {

      if (!this.submitButtonEnabled) {
        return
      }

      // if (this.$route.params.rowHash) {
      //   requestBody['row_hash'] = this.$route.params.rowHash
      // }

      if (this.actionType === 'add') {
        await this.saveChangesAdd()
      } else {
        await this.saveChangesEdit()
        try {
          this.communicateEmbbededFields({
            event: 'onSave',
            rowState: this.fieldModel,
            rowHash: this.$route.params.rowHash ? this.$route.params.rowHash : null
          })
        } catch (e) {
        }
      }

    }
  }
}
</script>
<style>
.vs--disabled .vs__dropdown-toggle {
  background-color: #f8f8f8 !important;
  opacity: 0.5 !important;
}

input:disabled:not([type="checkbox"]) {
  opacity: 0.5 !important;
  background-color: #f8f8f8 !important;
  cursor: default !important;
}

.con-input-upload-custom {
  margin-left: -3px !important;
  margin-top: -8.7px !important;
  margin-bottom: -5px !important;
}

.vx-col:has(.richtext-field) {
  display: flex;
  flex-direction: column;
}

.vx-col:has(.richtext-field) > .richtext-field {
  order: 2;
}

.vx-col:has(.richtext-field) > .div:has(.vs-input--label) {
  order: 1;
}
.vx-col:has(.richtext-field) > #textHelp1 {
  order: 3;
}

.richtext-field .ql-editor {
  min-height: 300px;
}

/* Estilos para quill-editor desabilitado */
.richtext-field.quill-disabled .ql-toolbar {
  opacity: 0.5 !important;
  pointer-events: none !important;
  cursor: not-allowed !important;
}

.richtext-field.quill-disabled .ql-toolbar button,
.richtext-field.quill-disabled .ql-toolbar select,
.richtext-field.quill-disabled .ql-toolbar .ql-picker-label,
.richtext-field.quill-disabled .ql-toolbar .ql-picker-options {
  opacity: 0.5 !important;
  pointer-events: none !important;
  cursor: not-allowed !important;
}

.richtext-field.quill-disabled .ql-container {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}
</style>
<style scoped>
.custom-border>>>input:disabled {
  border: 1px solid rgba(0, 0, 0, 0.4) !important;
}

input:disabled:not([type="checkbox"]) {
  opacity: 0.5 !important;
  background-color: #f8f8f8 !important;
  cursor: default !important;
}

textarea:disabled {
  opacity: 0.5 !important;
  background-color: #f8f8f8 !important;
  cursor: default !important;
}

.vs-input--input:disabled,
.vs-input--input:disabled+.vs-input--placeholder {
  opacity: 0.5 !important;
}

.need-style-placeholder::-webkit-input-placeholder {
  color: rgba(0, 0, 0, .4);
  font-size: .85rem !important;
  font-family: "Montserrat", Helvetica, Arial, sans-serif !important;
  font-weight: 400 !important;
}

.showing {
  display: block;
}

.hidding {
  display: none;
  transition: 2s;
}

.con-vs-chip {
  min-width: 50px !important;
  font-size: 0.9rem !important;
  width: 100% !important;
}
</style>
